export const translations = {
  uz: {
    // NAV
    dashboard: 'Dashboard',
    floor: 'Zal',
    kassa: 'Kassa',
    obuna: 'Obuna',
    superAdmin: 'Super Admin',
    computers: 'Kompyuterlar',
    packages: 'Paketlar',
    sessions: 'Sessiyalar',
    bookings: 'Bronlar',
    logout: 'Chiqish',

    // NAV — barcha sahifalar
    nav_dashboard: 'Dashboard',
    nav_floor: 'Zal',
    nav_kassa: 'Kassa',
    nav_bar_preorders: 'Bar buyurtmalar',
    nav_sessions: 'Sessiyalar',
    nav_bookings: 'Bronlar',
    nav_clients: 'Mijozlar',
    nav_announcements: "E'lonlar & Chegirmalar",
    nav_feedbacks: 'Shikoyat/Taklif',
    nav_notifications: 'Bildirishnomalar',
    nav_finance: 'Moliya & Analitika',
    nav_expenses: 'Xarajatlar',
    nav_staff: 'Xodimlar & Oylik',
    nav_crm: 'CRM',
    nav_snack: 'Snack-bar',
    nav_promotions: 'Aksiyalar',
    nav_topup_bonuses: "To'ldirish bonusi",
    nav_promo: 'Promo / Sodiqlik',
    nav_memberships: 'Abonement & HH',
    nav_tournaments: 'Turnirlar',
    nav_refunds: 'Qaytarish',
    nav_rewards: "Sovg'alar",
    nav_leaderboard: 'Leaderboard',
    nav_games: "O'yinlar",
    nav_apps: 'Dasturlar katalogi',
    nav_packages: 'Paketlar',
    nav_computers: 'Kompyuterlar',
    nav_maintenance: 'Texnik xizmat',
    nav_lab_info: "Klub ma'lumot",
    nav_layout_editor: 'Zal muharriri',
    nav_launcher_themes: 'Launcher dizaynlari',
    nav_payment_settings: "To'lov sozlamalari",
    nav_fiscal: 'Fiskal KKM',
    nav_access_control: 'Kirish huquqlari',
    nav_theme: 'Dizayn & Tema',
    nav_obuna: 'Obuna',
    nav_super_admin: 'Super Admin',

    // DASHBOARD
    greeting: 'Salom',
    todayStatus: 'Bugungi holat',
    todayUsers: 'Bugungi mijozlar',
    activeSessions: 'Band kompyuterlar',
    todayIncome: 'Bugungi daromad',
    available: "Bo'sh",
    revenueChart: 'Daromad grafigi',
    last7days: "So'nggi 7 kun",
    last30days: "So'nggi 30 kun",
    topComputers: 'Eng faol PClar (30 kun)',
    noData: "Ma'lumot yo'q",
    sum: "so'm",
    sessions_: 'sessiya',
    loading: 'Yuklanmoqda...',

    // BOOKINGS
    allBookings: 'Barcha bronlar',
    pending: 'Kutmoqda',
    confirmed: 'Tasdiqlangan',
    cancelled: 'Bekor qilingan',
    completed: 'Tugallangan',
    confirm: 'Tasdiqlash',
    cancel: 'Bekor qilish',
    user: 'Foydalanuvchi',
    lab: 'Xona',
    package: 'Paket',
    scheduledAt: 'Vaqt',
    status: 'Holat',
    actions: 'Amallar',

    // SESSIONS
    allSessions: 'Barcha sessiyalar',
    active: 'Faol',
    computer: 'Kompyuter',
    started: 'Boshlandi',
    ends: 'Tugaydi',
    paid: "To'langan",
    guest: 'Mehmon',

    // COMMON
    refresh: 'Yangilash',
    close: "Yopish",
    save: 'Saqlash',
    yes: 'Ha',
    no: "Yo'q",
    error: 'Xatolik',
    success: 'Muvaffaqiyat',
    somPerMonth: "so'm/oy",
    add: "Qo'shish",
    edit: 'Tahrirlash',
    delete: "O'chirish",
    search: 'Qidirish',
    filter: 'Filtrlash',
    export: 'Eksport',
    print: 'Chop etish',
    send: 'Yuborish',
    total: 'Jami',
    name: 'Ism',
    phone: 'Telefon',
    date: 'Sana',
    amount: 'Summa',
    balance: 'Balans',
    type: 'Tur',
    description: 'Tavsif',
    owner: 'Egasi',
    staff: 'Xodim',
    noItems: "Ma'lumot yo'q",
    back: 'Orqaga',

    // KASSA & SMENA
    kassaTitle: '💰 Kassa & Smena',
    shiftOpen: 'Smena ochiq',
    shiftClosed: 'Smena yopiq',
    openShift: 'Smena ochish',
    closeShift: 'Smenani yopish',
    shiftHistory: 'Smena tarixi',
    noShifts: "Smena yo'q",
    xReport: '📋 X-Hisobot',
    zReport: '🧾 Z-Hisobot',
    openShiftBtn: '🔓 Smenani ochish',
    closeShiftBtn: '🔒 Z-Hisobot + Yopish',
    xReportInterim: '📋 X-Hisobot (oraliq)',
    zReportFinal: '🧾 Z-Hisobot (yakuniy)',
    shiftOpened: 'Smena ochildi',
    shiftClosed2: 'Smena yopildi',
    cashRegister: 'Naqd hisobi',
    expectedCash: 'Kutilgan naqd',
    actualCash: 'Haqiqiy naqd',
    openingCash: 'Boshlanish naqd',
    cashShortage: "Tanqislik / Ortiqcha",
    sessionRevenue: 'Sessiya daromadi',
    snackRevenue: 'Snack daromadi',
    totalRevenue: 'Jami tushum',
    sessionsCount: 'Sessiyalar soni',
    newClients: 'Yangi mijozlar',
    cashInRegister: 'Kassadagi naqd',
    cashInRegisterLabel: 'Naqd (kassada)',
    cardPayment: 'Karta',
    balancePayment: 'Balansdan',
    cashPayment: 'Naqd',
    action_session_start: 'Sessiya boshlandi',
    action_session_end: 'Sessiya tugadi',
    action_session_force_end: "Majburiy to'xtatildi",
    action_walkin_start: 'Walk-in sessiya',
    action_walkin_stop: "Walk-in to'xtaldi",
    action_topup_test: "Test to'lovi",
    action_topup_click: "Click to'lovi",
    action_topup_payme: "Payme to'lovi",
    action_shift_open: 'Smena ochildi',
    action_shift_close: 'Smena yopildi',
    action_expense_add: "Xarajat qo'shildi",
    operator: 'Operator',
    opened: 'Ochildi',
    closed: 'Yopildi',

    // ZAL (FLOOR)
    floorTitle: '🖥️ Zal boshqaruvi',
    statusAvailableFloor: "Bo'sh",
    statusBusyFloor: 'Band',
    statusBrokenFloor: 'Buzilgan',
    statusBooked: 'Bron',
    statusOffline: "O'chiq",
    statusMaintenance: 'Texnik',
    startSession: 'Sessiya boshlash',
    endSession: 'Yakunlash',
    addTime: "Vaqt qo'shish",
    selectPackage: 'Paket tanlang',
    selectUser: 'Foydalanuvchi',
    enterPhone: 'Telefon raqam',
    guestEntry: 'Mehmon kirishi',
    minsLeft: 'daqiqa qoldi',
    hoursShort: 's',
    minsShort: 'd',
    realLayout: '🗺️ Real joylashuv',
    floorBusy: 'band',
    floorFree: "bo'sh",
    floorTotal: 'jami PC',
    sessionOpenTitle: 'Sessiya ochish',
    manageTitle: 'Boshqarish',
    packagedMode: '📦 Paketli',
    hourlyMode: '⏱️ Soatlik',
    phoneOptional: 'TELEFON RAQAM (ixtiyoriy)',
    balanceLabel: 'Balans',
    guestNamePlaceholder: 'Ism (naqd mijoz)...',
    timedSessionInfo: "⏱️ Vaqt asosida hisoblash — sessiya to'xtatilganda to'lanadi",
    packageLabel: 'PAKET',
    minutesShort: 'daqiqa',
    roomNotAllowed: 'bu xona uchun emas',
    allRooms: 'barcha xonalar',
    noPackagesFound: "Paketlar topilmadi",
    continueFromBalance: "Paket tugagach balansdan davom etsin",
    paymentTypeLabel: "TO'LOV TURI",
    cashOption: '💵 Naqd pul',
    cardOption: '💳 Karta',
    balanceOption: '📱 Ilova balansi',
    startBtn: '▶ Boshlash',
    cancelShort: 'Bekor',
    addTopupTitle: "💰 BALANSGA PUL QO'SHISH",
    topupSuccess: '✓ Muvaffaqiyatli yuborildi!',
    receiveMoneyLabel: "💵 PUL QABUL QILINDI — VAQT QO'SHISH",
    amountPlaceholder: "Summa (so'm)...",
    addMinutesBtn: 'daqiqa qo\'shish',
    enterAmount: 'Summa kiriting',
    priceNotFound: "⚠️ Narx ma'lumoti topilmadi",
    moveToPC: "BOSHQA PC GA KO'CHIRISH",
    selectPCPlaceholder: 'PC tanlang...',
    moveBtn: "Ko'chir",
    remoteControl: 'MASOFADAN BOSHQARUV',
    stopSessionBtn: "⏹ Sessiyani to'xtatish",
    clientLabel: 'Mijoz',
    packageField: 'Paket',
    timeLeftLabel: 'Qolgan vaqt',
    paidLabel: "To'lov",
    typeField: 'Tur',
    timedType: '⏱️ Soatlik',
    elapsedLabel: "O'tgan vaqt",
    pricePerHour: "so'm/soat",
    payTypeLabel: "To'lov turi",
    cashLabel: 'Naqd',
    cardLabel: 'Karta',
    appBalanceLabel: 'Ilova balansi',
    onlineTag: 'yoniq',
    offlineTag: "o'chiq",
    timedMode: '⏱️ Vaqt asosida',
    manageBtn: '⚙ Boshqar',
    freeSessionBtn: '+ Sessiya ochish',
    freeStartBtn: '+ Boshlash',
    pcOnline: 'Yoniq',
    pcOffline: "O'chiq",
    emptyPC: "Bu PC hozir bo'sh.",
    manageArrow: 'Boshqarish →',
    turnOnBtn: '⚡ Yoqish (Wake-on-LAN)',
    turnOffBtn: '⏻ O\'chirish',
    openSessionAction: '▶ Sessiya ochish',
    addBookingAction: '🔖 Bron qo\'shish',
    maintenanceActivate: '✓ Texnik ish tugadi — Faollashtirish',
    maintenanceSet: '🔧 Texnik ishlarga o\'tkazish',
    bookTitle: 'Bron qo\'shish',
    guestNameLabel: 'MIJOZ ISMI (ixtiyoriy)',
    guestNamePlh: 'Ism yoki familiya...',
    phoneWithLookup: 'TELEFON (ixtiyoriy — bazada bo\'lsa topiladi)',
    dateLabel2: 'SANA',
    fromTimeLabel: 'DAN (soat)',
    toTimeLabel: 'GACHA (ixtiyoriy)',
    packageOptional: 'PAKET (ixtiyoriy)',
    withoutPackage: '— Paketsiz —',
    bookAction: '🔖 Bron qilish',
    warningTimeEnding: 'Vaqt tugayapti!',
    addTimeOrTopup: "Vaqt qo'shing yoki foydalanuvchi balansini to'ldiring",
    guestCash: 'Naqd mijoz',

    // FINANCE
    financeTitle: 'Moliya & Analitika',
    revenue: 'Daromad',
    expenses: 'Xarajatlar',
    profit: 'Foyda',
    profitLoss: 'Foyda / Zarar',
    topCustomers: 'Top mijozlar',
    byComputer: 'Kompyuter bo\'yicha',
    debtors: 'Qarzdorlar',
    suspiciousActivity: 'Shubhali harakatlar',
    snackSales: 'Bar savdosi',
    totalSales: 'Jami savdo',
    margin: 'Foyda',
    noSnackSales: "Bar savdosi yo'q",
    noTopup: "Topup yo'q",
    noSessions: "Sessiya bo'lmagan",
    normal: 'Normal ishlayapti',
    noAnomalies: 'Shubhali harakatlar aniqlanmadi',

    // PACKAGES
    duration2: 'Davomiylik',
    packagesTitle: '📦 Paketlar',
    addPackage: "Paket qo'shish",
    editPackage: 'Paketni tahrirlash',
    packageName: 'Paket nomi',
    price: 'Narx',
    duration: 'Davomiylik (daqiqa)',
    type_time: 'Vaqt',
    type_night: 'Tungi',
    type_hourly: 'Soatlik',
    noPackages: "Paket yo'q",

    // COMPUTERS
    computersTitle: '🖥️ Kompyuterlar',
    addComputer: "Kompyuter qo'shish",
    editComputer: 'Kompyuterni tahrirlash',
    computerNumber: 'Raqam',
    computerSpec: 'Xususiyatlar',
    noComputers: "Kompyuter yo'q",

    // CLIENTS / CRM
    clientsTitle: '👥 Mijozlar',
    allClients: 'Barcha mijozlar',
    totalSpent: "Jami sarflagan",
    totalSessions: 'Sessiyalar',
    lastVisit: 'Oxirgi tashrif',
    registered: "Ro'yxatdan o'tgan",
    addNote: "Izoh qo'shish",
    noNotes: "Izoh yo'q",
    sendBonus: 'Bonus yuborish',
    sendPush: 'Push xabar',

    // STAFF
    staffTitle: '👥 Xodimlar',
    salary: 'Maosh',
    salaryHistory: 'Maosh tarixi',
    paySalary: 'Maosh berish',

    // FINANCE tabs
    tab_topup: "To'ldirish",
    tab_snack: 'Snack',
    tab_sessions: 'Sessiyalar',
    tab_shifts: 'Smenalar',
    tab_expenses: 'Xarajatlar',
    tab_debtors: 'Qarzdorlar',
    tab_anomalies: 'Anomaliyalar',
    tab_all: 'Barchasi',

    // NOTIFICATIONS
    notificationsTitle: '🔔 Bildirishnomalar',
    sendNotification: 'Bildirishnoma yuborish',
    allUsers: 'Barcha foydalanuvchilar',
    titleLabel: 'Sarlavha',
    bodyLabel: 'Matn',
    fcmConnected: '🟢 Firebase ulangan',
    fcmNotConfigured: '🔴 Firebase sozlanmagan',
    fcmWarningTitle: '⚠️ Firebase sozlanmagan',
    tabBroadcast: '📢 Broadcast',
    tabComputer: '🖥️ Kompyuter',
    tabHistory: '📋 Tarix',
    tabTest: '🧪 Test',
    broadcastSendTitle: 'Broadcast yuborish',
    titlePlhNotif: 'Masalan: Yangi aksiya!',
    bodyPlhNotif: 'Bildirishnoma matni...',
    sendBtn: '📢 Yuborish',
    broadcastFootnote: "Filialdagi oxirgi 30 kun ichida sessiya yoki bron qilgan barcha foydalanuvchilarga yuboriladi.",
    templatesTitle: '📋 Tayyor shablonlar',
    refreshBtn: '🔄 Yangilash',
    noNotifications: "Bildirishnomalar yo'q",
    pcMsgTitle: 'Kompyuterga xabar',
    pcMsgDesc: "Xabar kompyuter ekranida darhol ko'rinadi (agent ishlayotgan bo'lsa).",
    pcSelectLabel: 'Kompyuter',
    pcMsgLabel: 'Xabar matni',
    pcMsgPlh: 'Masalan: 5 daqiqada filial yopiladi...',
    quickMsgsTitle: 'Tez xabarlar',
    sentMsgsTitle: 'Yuborilgan xabarlar',
    noMsgsSent: 'Hali xabar yuborilmagan',
    msgSeen: "Ko'rildi",
    msgPending: '⏳ Kutilmoqda',
    sendToPcBtn: '🖥️ Kompyuterga yuborish',
    testTitle: 'Test bildirishnoma',
    testDesc: "Foydalanuvchi qurilmasining FCM tokenini kiriting — brauzer konsolida yoki Flutter debug logdan olish mumkin.",
    fcmTokenLabel: 'FCM Token',
    fcmTokenPlh: 'fcm token (uzun qator)...',
    sendTestBtn: '🧪 Test yuborish',
    fcmNotConfiguredTest: "Firebase sozlanmagan — test yuborib bo'lmaydi",
    newBadge: 'Yangi',
    pcBusy: 'Band',
    pcFree: "Bo'sh",

    // PROMOTIONS
    promotionsTitle: "🎯 Aksiyalar / Chegirmalar",
    addPromotion: '+ YANGI AKSIYA',
    noPromotions: "Hozircha aksiya yo'q",
    noPromotionsHint: '"+ YANGI AKSIYA" bosib e\'lon qiling',
    statusActivePromo: 'FAOL',
    statusInactive: 'NOFAOL',
    expiresOn: 'Tugaydi',
    unlimited: 'Muddatsiz',
    editItem: 'TAHRIR',
    editPromotion: 'Aksiyani tahrirlash',
    newPromotion: 'Yangi aksiya',
    descLabel: 'Tavsif',
    expiresAtLabel: 'Tugash sanasi',
    imageUrlLabel: 'Rasm URL (ixtiyoriy)',
    activeLabel: 'Faol',
    alertTitleRequired: 'Sarlavha kiriting',
    confirmDeletePromo: "Aksiyani o'chirasizmi?",
    promotionsSubtitle: 'mobile ilovaning "Chegirmalar" bo\'limida ko\'rinadi',
    clubNotSelected: 'Klub tanlang',

    // COMPUTERS
    computersPageTitle: 'Kompyuterlar',
    pcCount: 'ta kompyuter',
    addPc: '+ PC Qo\'shish',
    noPcs: 'Hozircha kompyuter yo\'q. + PC Qo\'shish tugmasini bosing.',
    statusAvailable: 'Bo\'sh',
    statusBusy: 'Band',
    statusBroken: 'Nosoz',
    autoShutdown: 'Avtomatik o\'chirish',
    autoShutdownDesc: 'Sessiya tugagandan keyin kompyuter ma\'lum vaqt bo\'sh qolsa, avtomatik o\'chiriladi. Elektr tejash uchun.',
    enabled: 'Yoqilgan',
    disabled: 'O\'chirilgan',
    saving: 'Saqlanmoqda...',
    idleTime: 'Bo\'sh qolish vaqti:',
    min: 'daq',
    bookingDeposit: 'Bron zalogi',
    bookingDepositDesc: 'Mijoz bron qilganda oldindan undiriladigan zalog miqdori. Kelmasa — zalog qaytarilmaydi. 0 qo\'yilsa zalog olinmaydi.',
    currency: 'so\'m',
    currentDeposit: 'Hozirgi:',
    addPcTitle: 'Yangi PC Qo\'shish',
    branchLabel: 'Filial',
    pcNumber: 'PC raqami',
    add: 'Qo\'shish',

    // PACKAGES
    packagesPageTitle: 'Paketlar',
    packagesSubtitle: 'Narx va vaqt sozlamalari',
    addPackageBtn: '+ Paket Qo\'shish',
    bookingDepositByRoom: 'Bron zalogi — xonaga qarab',
    bookingDepositByRoomDesc: 'Har bir xona uchun alohida zalog belgilang. 0 = zalog yo\'q. Kelmasa qaytarilmaydi.',
    noRooms: 'Bu filialda hali xona qo\'shilmagan. Avval zal muharririda xona yarating.',
    noRoomsFound: 'Xonalar topilmadi (avval xona yarating)',
    noPackagesList: 'Hozircha paket yo\'q. + Paket Qo\'shish tugmasini bosing.',
    roomNotSet: 'Xona belgilanmagan',
    perHour: 'so\'m/soat',
    editPkg: 'Tahrirlash',
    editPackageTitle: 'Paketni tahrirlash',
    newPackageTitle: 'Yangi Paket',
    packageNameLabel: 'Paket nomi',
    durationLabel: 'Davomiyligi (daqiqada)',
    priceLabel: 'Narxi (so\'mda)',
    roomSelectLabel: 'XONA TANLANG',
    roomSelectRequired: 'Kamida 1 ta xona tanlanishi shart',
    minOneRoom: 'Kamida bitta xona tanlanishi kerak',
    update: 'Yangilash',
    savedCheck: '✓ Saqlandi',

    // PACKAGES — smart fields
    pkgTypeLabel: 'Paket turi',
    pkgTypeSmall: 'Kichik (kundalik)',
    pkgTypeBig: 'Katta (promo)',
    pkgFirstPurchaseOnly: 'Faqat yangi mijozlarga',
    pkgMaxAvgHours: 'Faqat shu soatdan kamroq o\'ynaganlar uchun (0 = cheklovsiz)',
    pkgIsRecommended: 'Tavsiya etilgan paket (har xonada 1 ta)',
    pkgDiscountLabel: 'Chegirma',
    pkgDiscountWarn: 'Bu paket oddiy tarifdan {pct}% arzon',
    pkgSimTitle: 'Daromad simulyatsiyasi (o\'tgan oy)',
    pkgSimLoading: 'Hisoblanmoqda...',
    pkgSimResult: '{count} ta mijoz bu paketni olganida daromad {sign}{amt} so\'mga o\'zgarardi',
    pkgSimNote: '* Bu taxminiy hisob',
    pkgSimNoRate: 'Soatlik tarif belgilanmagan — simulyatsiya mavjud emas',

    // EXPENSES
    expensesTitle: '💸 Xarajatlar',
    expensesSubtitle: 'Ijara, oylik, elektr va boshqa xarajatlar',
    addExpenseBtn: 'Xarajat qo\'shish',
    totalExpenses: 'Jami xarajat',
    noExpenses: 'Xarajat yo\'q',
    noExpensesHint: 'Birinchi xarajatni qo\'shing',
    categoryLabel: 'Kategoriya',
    amountLabel: 'Summa (so\'m)',
    dateLabel: 'Sana',
    recurMonthly: 'Har oy takrorlanadi',
    confirmDelete: 'O\'chirishni tasdiqlaysizmi?',
    cat_ijara: 'Ijara',
    cat_oylik: 'Oylik',
    cat_elektr: 'Elektr',
    cat_internet: 'Internet',
    cat_jihoz: 'Jihoz',
    cat_snack: 'Snack ta\'minot',
    cat_marketing: 'Marketing',
    cat_tamir: 'Ta\'mir',
    cat_soliq: 'Soliq',
    cat_boshqa: 'Boshqa',
    editExpenseTitle: 'Tahrirlash',
    newExpenseTitle: 'Yangi xarajat',
    alertAmountRequired: 'Kategoriya va summa kerak',
    tableActions: 'Amallar',
    tableRecurring: 'Takrorlanadi',
    tableDate: 'Sana',
    tableCategory: 'Kategoriya',
    tableDesc: 'Tavsif',
    tableAmount: 'Summa',
    recurEveryMonth: 'Har oy',

    // ANNOUNCEMENTS
    announcementsTitle: "📢 E'lonlar",
    addAnnouncement: "E'lon qo'shish",
    validUntil: 'Amal qilish muddati',
    discountPct: 'Chegirma %',
    annSubtitle: 'Klub mijozlariga yangilik yoki chegirma haqida push xabar yuborish.',
    annBranchLabel: 'Filial:',
    subInactive: 'Obuna faol emas',
    subInactiveDesc: "E'lon yaratish va push xabar yuborish faqat faol obuna orqali ishlaydi. Ilgari yaratilgan e'lonlar ko'rinadi, lekin yangi yaratib bo'lmaydi.",
    viewSubscription: "Obunani ko'rish →",
    subActive: 'Obuna faol',
    trialPeriod: 'demo davri',
    daysLeftAnn: 'Qolgan',
    dayUnit: 'kun',
    newAnnouncement: "Yangi e'lon",
    type_news: 'Yangilik',
    type_discount: 'Chegirma',
    type_event: 'Tadbir',
    type_tournament: 'Turnir',
    annTitlePlh: 'Sarlavha (masalan: 30% chegirma kechqurun!)',
    annBodyPlh: 'Matn — mijozlarga xabar (masalan: Bugun soat 18:00 dan 22:00 gacha...)',
    imageUrlOptional: 'Rasm URL (ixtiyoriy)',
    ctaUrlOptional: 'Havola URL (ixtiyoriy — tugma)',
    expiryOptional: 'Muddat tugashi (ixtiyoriy)',
    pinToTop: "Yuqoriga tashlab qo'yish",
    sendPushLabel: 'Mobil push yuborish',
    sending: 'Yuborilyapti...',
    sendAnnouncement: "📢 E'lonni yuborish",
    annListHeader: "Yaratilgan e'lonlar",
    noAnnouncements: "Hozircha e'lonlar yo'q. Yuqoridagi formadan birinchi yangilikni e'lon qiling.",
    annPinned: 'Pinlangan',
    annArchived: 'Arxivda',
    annPushSent: 'Push yuborildi',
    annCreatedAt: 'Yaratilgan',
    unpin: 'Pindan olish',
    pinBtn: 'Pinlash',
    activateBtn: 'Aktivlashtirish',
    archiveBtn: 'Arxiv',
    deleteBtn: "O'chirish",
    confirmDeleteAnn: "Ushbu e'lonni o'chirishni tasdiqlaysizmi?",
    errTitleBody: 'Sarlavha va matn kerak',
    errSubRequired: "❗ Faqat faol obuna orqali ishlaydi. Obuna sahifasiga o'ting.",
    errSubOnly: '❗ Faqat obuna orqali',

    // MEMBERSHIPS
    membershipsTitle: '💎 Abonement',
    addMembership: 'Abonement qo\'shish',
    discountTitle: 'Chegirma',
    sessionsLimit: 'Sessiyalar chegarasi',
    membershipsPageTitle: '💎 Abonement & Happy Hour',
    membershipsSubtitle: 'Obuna rejalari va maxsus soatlar',
    tabAbonement: '💎 Abonementlar',
    tabHappyHour: '⏰ Happy Hour',
    activeAbonements: 'Faol abonementlar',
    monthlyAbonRevenue: 'Bu oylik abonement daromad',
    plansHeader: 'Planlar',
    addPlan: '➕ Plan qo\'shish',
    nameLabel: 'Nom',
    priceSumLabel: 'Narx (so\'m)',
    durationDaysLabel: 'Muddat (kun)',
    sessionLimitLabel: 'Sessiya limiti (0=cheksiz)',
    dayUnit2: 'kun',
    discountSuffix: 'chegirma',
    sessionUnit: 'sessiya',
    unlimitedSessions: 'Cheksiz sessiya',
    deleteBtn2: 'O\'chirish',
    activeAbonementsHeader: 'Faol abonementlar',
    noActiveAbonements: 'Faol abonement yo\'q',
    colUser: 'Foydalanuvchi',
    colPlan: 'Plan',
    colStartDate: 'Boshlanish',
    colEndDate: 'Tugash',
    colSessions: 'Sessiyalar',
    alertNamePrice: 'Nom va narx kerak',
    alertNameRequired: 'Nom kerak',
    hhActiveNow: 'Happy Hour hozir faol!',
    addHH: '➕ Qo\'shish',
    newHHTitle: '➕ Yangi Happy Hour',
    dayLabel: 'Kun',
    hourFromLabel: 'Boshlanish soati (0-23)',
    hourToLabel: 'Tugash soati (0-23)',
    noHappyHours: 'Happy Hour qo\'shilmagan',
    colName: 'Nom',
    colDay: 'Kun',
    colNow: 'Hozir',
    colEnabled: 'Faol',
    activeNow: 'Faol',
    day_all: 'Barcha kunlar',
    day_0: 'Yakshanba',
    day_1: 'Dushanba',
    day_2: 'Seshanba',
    day_3: 'Chorshanba',
    day_4: 'Payshanba',
    day_5: 'Juma',
    day_6: 'Shanba',

    // TOURNAMENTS
    tournamentsTitle: '🏆 Turnirlar',
    prizePool: 'Mukofot jamg\'armasi',
    participants: 'Qatnashchilar',
    maxParticipants: 'Maks qatnashchilar',

    // MAINTENANCE
    maintenanceTitle: '🔧 Texnik xizmat',
    issue: 'Muammo',
    reportIssue: 'Muammo bildirish',
    resolve: 'Hal qilindi',

    // ROLE LABELS
    roleOwner: 'Egasi',
    roleStaff: 'Xodim',
    branch: 'Filial',
    allLabs: 'Hammasi',
    selectLabForShift: 'Smenani boshqarish uchun klubni tanlang',

    // PERIOD PICKER
    today: 'Bugun',
    thisMonth: 'Bu oy',

    // KASSA — additional
    todayRevenue: 'Bugungi daromad',
    walkinSessions: 'Walk-in sessiyalar',
    avgSession: "O'rtacha sessiya",
    auditLog: 'Audit log',
    noRecords: "Hozircha yozuvlar yo'q",
    openTag: 'ochiq',
    shortage: 'Kamomad',
    surplus: 'Ortiqcha',
    closingCashLabel: "Kassadagi haqiqiy naqd pul (so'm)",
    openingCashLabel: "Boshlang'ich naqd (kassadagi pul)",
    noteLabel: 'Izoh',
    optionalPlaceholder: 'Ixtiyoriy...',
    whoOpening: 'Kim ochyapti *',
    selectPlaceholder: '— Tanlang —',
    payMethodPC: "Sessiya daromadi (PC + Bilyard + PS)",
    colTime: 'Vaqt',
    colAction: 'Harakat',
    colWho: 'Kim',
    colAmount: 'Miqdor',
    colDetails: 'Batafsil',
    printReport: 'Chop etish',
    sessionsLabel: 'Sessiyalar',
    newClientsLabel: 'Yangi mijozlar',
    cashInRegisterModal: 'Kassadagi naqd',

    // BAR PRE-ORDERS
    barPreorders: '🍔 Bardan oldindan buyurtmalar',
    allClubs: 'Barcha klublar',
    club: 'Klub',
    noBarOrders: "Hozircha bardan buyurtmalar yo'q",
    activeOrders: 'Aktiv',
    historyOrders: 'Tarix',
    booking: 'Bron',
    arrivalTime: 'Kelish vaqti',
    minsRemaining: 'daq qoldi',
    btnUnderstood: "TUSHUNDIM — Tayyorlab qo'yaman",
    btnMarkCash: "Naqdga o'tkaz",
    btnCancelOrder: 'Bekor qil',
    btnDelivered: 'OBORIB BERDIM',
    orderCompleted: 'Yakunlandi',
    confirmMarkCash: "Bu buyurtmani naqd sifatida qabul qilasizmi? (Mijoz yetkazishda to'laydi)",
    confirmCancelOrder: "Buyurtmani bekor qilib arxivlaysizmi? Balansdan olingan pul mijozga qaytariladi.",
    // TOURNAMENTS (full)
    tournamentsSubtitle: 'Filial turnirlarini tashkil qilish va boshqarish',
    newTournament: '+ Yangi turnir',
    newTournamentForm: 'Yangi turnir',
    tournamentName: 'Turnir nomi *',
    tournamentGame: "O'yin (CS2, FC24...)",
    tournamentDescription: 'Tavsif...',
    tournamentEntryFee: "Ishtirok to'lovi (so'm)",
    tournamentPrizePool: "Sovrin fondi (so'm)",
    tournamentMaxPlayers: 'Max qatnashchi',
    tournamentCreate: 'Yaratish',
    statusUpcoming: 'Kutilmoqda',
    statusActive: 'Davom etmoqda',
    statusFinished: 'Tugadi',
    statusCancelled: 'Bekor',
    tournamentBack: '← Orqaga',
    tournamentStart: '▶️ Boshlash',
    tournamentFinish: '🏆 Yakunlash',
    tournamentCancel: '✗ Bekor qilish',
    participantName: 'Qatnashchi ismi...',
    addParticipant: "+ Qo'shish",
    participantPaid: "✓ To'langan",
    participantUnpaid: "To'lanmagan",
    participantsLabel: 'Qatnashchilar',
    noParticipants: "Hali hech kim yo'q",
    entryFeeLabel: "Ishtirok to'lovi",
    collectedFees: "Yig'ilgan to'lov",
    entryFeeEntry: "so'm kirish",
    noTournaments: "Turnirlar yo'q",
    noTournamentsDesc: 'Birinchi turnirni yarating va mijozlarni jalb qiling',
    guestLabel: 'Mehmon',

    // GAMES (full)
    gamesTitle: "🎮 O'yinlar boshqaruvi",
    gamesSubtitle: "Desktop agentda ko'rinadigan o'yinlar, poster va mp4 trailerlar",
    addGame: "+ O'yin qo'shish",
    gameName: "O'yin nomi *",
    gameSort: 'Tartib',
    gameExePath: "Exe yo'li (masalan: C:\\Games\\CS2\\cs2.exe)",
    gameShortDesc: "Qisqa tasnif — 1-2 jumla (hero panelda ko'rinadi)",
    gameFullDesc: "To'liq tavsif — sujet, qoidalar, xususiyatlar (o'yin sahifasida to'liq ko'rinadi)",
    gameEditTitle: 'Tahrirlash',
    gameNewTitle: "Yangi o'yin",
    gameInactive: 'Nofaol',
    deleteGameConfirm: "O'yinni o'chirmoqchimisiz?",
    fileTooLarge: 'Fayl hajmi juda katta. Maks:',
    uploadError: 'Yuklashda xatolik',
    coverBtn: '🖼️ Karta rasmi',
    coverBtnDone: '🖼️ Karta ✓',
    heroBtn: '🎨 Tema rasmi',
    heroBtnDone: '🎨 Tema ✓',
    trailerBtn: '🎬 Trailer',
    trailerBtnDone: '🎬 Trailer ✓',
    editGameBtn: '✏️ Tahrirlash',
    genreOther: '🎮 Boshqa',
    noGames: "Hech qanday o'yin qo'shilmagan",
    noGamesDesc: "Desktop agentda ko'rinadigan o'yinlarni qo'shing",

    // MAINTENANCE (full)
    maintenanceSubtitle: 'Muammolar tarixi va PC spesifikatsiyalari',
    mainTabIssues: '⚠️ Muammolar',
    mainTabSpecs: '🖥️ PC Spesifikatsiya',
    openIssues: 'Ochiq muammolar',
    inProgressLabel: 'Jarayonda',
    resolvedMonth: 'Bu oy hal qilindi',
    totalCost: 'Jami xarajat',
    filterAll: 'Barchasi',
    filterOpen: 'Ochiq',
    filterInProgress: 'Jarayonda',
    filterResolved: 'Hal qilindi',
    addIssue: "➕ Muammo qo'shish",
    newIssueTitle: '🔧 Yangi muammo',
    issueComputer: 'Kompyuter',
    selectComputerPlaceholder: '— Tanlang —',
    issueTechnician: 'Texnik',
    technicianPlaceholder: 'Texnik ismi',
    issueCost: "Xarajat (so'm)",
    issueNotes: 'Izoh',
    issueDesc: 'Muammo tavsifi',
    issuePlaceholder: 'Muammo haqida yozing...',
    missingIssueDesc: 'Muammo tavsifi kerak',
    colPC: 'PC',
    colIssue: 'Muammo',
    colStatus: 'Status',
    colTechnician: 'Texnik',
    colCostHdr: 'Xarajat',
    colDate: 'Sana',
    colActions: 'Amallar',
    noIssues: "Muammolar yo'q",
    statusOpen: 'Ochiq',
    statusInProgress: 'Jarayonda',
    statusResolved: 'Hal qilindi',
    specsType: 'Tur',
    specsGPU: 'GPU',
    specsRAM: 'RAM',
    specsStorage: 'Xotira',
    specsCondition: 'Holat',
    specsBroken: '🔴 Buzuq',
    specsGood: '✅ Yaxshi',
    specsBrokenShort: 'Buzuq',
    specsGoodShort: 'Yaxshi',

    // OBUNA (full)
    obunaTitleFull: '📋 Obuna holati',
    obunaSubtitle: 'Defuse SaaS — ayliq obuna boshqaruvi',
    currentStatus: 'Joriy holat',
    computersLabel: 'Kompyuterlar',
    daysLeft: 'Kun qoldi',
    limitLabel: 'Limit',
    statusTrial: 'Sinov davri',
    statusExpired: "Muddati o'tgan",
    statusCancelledSub: 'Bekor qilingan',
    statusActiveSub: 'Faol',
    trialUntil: 'Sinov:',
    trialUntilSuffix: 'gacha',
    expiresLabel: 'Tugaydi:',
    testModeNote: "Test rejimi — haqiqiy to'lovsiz obunani sinab ko'ring. Click/Payme integratsiyasi tez orada.",
    subscriptionPlans: 'Obuna rejalari',
    unlimitedComputers: 'Cheksiz',
    computersUpToSuffix: 'kompyutergacha',
    activePlanBadge: '✅ Joriy reja',
    recommendedBadge: '⭐ Tavsiya etiladi',
    activePlanLabel: 'Faol reja',
    testActivate: '🧪 Test aktivatsiya',
    activatingLabel: '⏳ Faollashtirilmoqda...',
    activatedSuccess: '✅ Obuna faollashtirildi! (Test rejimi)',
    realPaymentTitle: "Haqiqiy to'lov — Click / Payme",
    realPaymentDesc: "Merchant hisob ochilib, integratsiya qo'shiladi. Hozircha test rejimida ishlash mumkin.",
    comingSoon: 'Tez orada',
    planSuffix: 'rejasi',
    perMonth: "so'm/oy",

    // STAFF (full)
    roleKassir: 'Kassir',
    roleManager: 'Manager',
    roleTechnic: 'Texnik',
    staffPageTitle: 'Xodimlar & Oylik',
    staffPageSubtitle: "Xodimlarni boshqarish va oylik hisoblash",
    tabStaff: '👤 Xodimlar',
    tabSalary: '💰 Oyliklar',
    tabAttendance: '⏱ Davomat',
    addStaff: "➕ Xodim qo'shish",
    editStaffTitle: "✏️ Xodimni tahrirlash",
    newStaffTitle: "➕ Yangi xodim",
    staffNameLabel: 'Ism *',
    staffPhoneLabel: 'Telefon',
    positionLabel: 'Lavozim',
    salaryTypeLabel: 'Maosh turi',
    salaryMonthly: "📅 Oylik (belgilangan)",
    salaryWeekly: '📆 Haftalik',
    salaryShift: '⏱ Smenabay',
    salaryHourly: '🕐 Soatbay',
    rateHourlyLabel: "Soatlik stavka (so'm)",
    rateShiftLabel: "Smena stavkasi (so'm)",
    rateWeeklyLabel: "Haftalik stavka (so'm)",
    rateMonthlyLabel: "Oylik stavka (so'm)",
    staffNamePlh: 'Xodim ismi',
    noStaff: "Xodimlar yo'q",
    colStaffName: 'Ism',
    colPhone: 'Telefon',
    colPosition: 'Lavozim',
    colRate: 'Stavka',
    colActive: 'Faol',
    ratePerHour: '/soat',
    ratePerShift: '/smena',
    ratePerWeek: '/hafta',
    ratePerMonth: '/oy',
    staffNameRequired: 'Ism kiritilmadi',
    confirmDeleteStaff: "O'chirishni tasdiqlaysizmi?",
    salaryStaffRequired: 'Xodim va asosiy summa kerak',
    salarySaved: "Saqlandi ✓ Xarajatlar bo'limiga ham qo'shildi",
    monthlyTotalSummary: 'Bu oylik jami oylik',
    staffCountSuffix: 'ta xodim',
    salaryPaid: "To'langan",
    salaryPending: 'Kutilmoqda',
    selectStaffLabel: 'Xodim',
    selectStaffPlh: '— Xodim tanlang —',
    monthLabel: 'Oy',
    calcSalaryTitle: '📝 Maosh hisoblash',
    autoCalcTitle: '🧮 Avtomatik hisoblash',
    dateFromLabel: 'Dan',
    dateToLabel: 'Gacha',
    calcBtn: '🧮 Hisoblash',
    fillMonthlyBtn: "🧮 Oylik to'ldirish",
    shiftsCountLabel: 'Smenalar',
    shiftPriceLabel: 'Smena narxi',
    hoursCountLabel: 'Soatlar',
    hourPriceLabel: 'Soat narxi',
    weeksCountLabel: 'Haftalar',
    weekPriceLabel: 'Hafta narxi',
    calcSalaryResult: 'Hisoblangan maosh',
    recentSessionsLabel: "So'nggi sessiyalar",
    colStarted: 'Boshlandi',
    colEnded: 'Tugadi',
    hoursUnitsLabel: 'Soatlar soni',
    shiftsUnitsLabel: 'Smenalar soni',
    weeksUnitsLabel: 'Haftalar soni',
    baseAmountLabel: "Asosiy summa (so'm)",
    bonusLabel: 'Bonus',
    fineLabel: 'Jarima',
    advanceLabel: 'Avans (chegiriladi)',
    notesLabel: 'Izoh',
    optionalPlh: 'Ixtiyoriy...',
    totalSalaryLabel: 'Jami:',
    salaryHistoryTitle: 'Oylik tarixi',
    colMonth: 'Oy',
    colBase: 'Asosiy',
    colBonus: 'Bonus',
    colFine: 'Jarima',
    colAdvance: 'Avans',
    colTotal: 'Jami',
    salaryMarkedPaid: "✅ To'landi",
    salaryPendingStatus: '⏳ Kutilmoqda',
    markPaidBtn: "To'landi",
    activeAtWork: '● Ishda',
    restingLabel: '○ Dam',
    workHistoryBtn: '📋 Tarix',
    workHistoryLabel: 'ish tarixi',
    noWorkHistory: "Tarixi yo'q",
    colStartWork: 'Boshlash',
    colEndWork: 'Yakunlash',
    colDurationHdr: 'Davomiyligi',
    finishedStatus: '✓ Yakunlandi',

    // FEEDBACKS (full)
    feedbacksTitle: '📝 Shikoyat va takliflar',
    fbAllClubs: 'Barcha klublar',
    fbAllStatuses: 'Barcha holatlar',
    fbAllCategories: 'Barcha mavzular',
    fbStatusNew: 'Yangi',
    fbStatusInProgress: "Ko'rib chiqilmoqda",
    fbStatusResolved: 'Hal qilindi',
    fbStatTotal: 'Umumiy',
    fbStatComplaints: 'Shikoyat',
    fbStatSuggestions: 'Taklif',
    fbStatPraises: 'Rahmat',
    fbStatBugs: 'Xato',
    fbStatAvgRating: "O'rtacha baho",
    fbClubLabel: 'Klub:',
    fbAnonymous: '👤 Anonim',
    fbPublic: '🙋 Ochiq',
    fbOwnerResponse: 'Sizning javobingiz:',
    fbReply: 'Javob berish',
    fbMarkResolved: 'Hal qilingan deb belgilash',
    fbResponsePlh: "Foydalanuvchiga javob (agar anonim bo'lmasa mobil ilovada ko'radi)",
    fbSend: 'Yuborish',
    fbCancelReply: 'Bekor',
    fbNoMessages: "Xabarlar yo'q",
    catComplaint: '😠 Shikoyat',
    catSuggestion: '💡 Taklif',
    catPraise: '❤️ Rahmat',
    catBug: '🐛 Xato',
    catStaff: '👨 Xodim',
    catEquipment: '🖥️ Uskuna',
    catOther: '📝 Boshqa',

    // LEADERBOARD (full)
    leaderboardSubtitle: "Eng faol o'yinchilar reytingi",
    lbTotalPlayers: "Jami o'yinchilar",
    lbAvgXP: "O'rtacha XP",
    lbTopXP: 'Top XP',
    lbTotalHours: 'Jami soatlar',
    lbTop3Title: "Top 3 o'yinchi",
    lbFullRating: "To'liq reyting",
    lbColPlayer: "O'yinchi",
    lbColXPLevel: 'XP / Daraja',
    lbColSessions: 'Sessiyalar',
    lbColHours: 'Soatlar',
    lbColProgress: 'Progress',
    xpNeeded: 'XP kerak',
    lvlNew: 'Yangi',
    lvlActive: 'Faol',
    lvlPro: 'Pro',
    lvlLegend: 'Legend',

    // TOPUP BONUSES (full)
    topupTitle: "🎁 To'ldirish bonusi",
    topupCurrentBranch: 'Joriy filial:',
    topupDesc: "Mijoz balansga summa to'ldirsa, qoidaga qarab avtomatik bonus qo'shiladi.",
    topupMinAmountLabel: "To'ldirish summasi (so'm)",
    topupBonusAmountLabel: "Bonus summasi (so'm)",
    topupAddRule: "+ Qoida qo'shish",
    topupNoRules: "Hozircha bonus qoidasi yo'q",
    topupNoRulesHint: "Yuqoridagi forma orqali qo'shing",
    topupRuleHash: 'Qoida #',
    topupActive: '✓ Faol',
    topupInactive: "○ O'chirilgan",
    topupWhenDeposited: 'tushganda',
    topupEditBtn: '✏️ Tahrir',

    // PROMO (full)
    promoTitle: "🎟️ Promo-kodlar & Sodiqlik",
    promoSubtitle: 'Chegirmalar, bonus ballar va sodiqlik dasturi',
    tabPromoCode: "🎟️ Promo-kodlar",
    tabLoyalty: '⭐ Sodiqlik darajalari',
    promoNewCode: '+ Yangi kod',
    promoDiscountPercent: 'Foiz (%)',
    promoDiscountFixed: "Belgilangan (so'm)",
    promoDiscountPctPlh: 'Foiz (1-100)',
    promoDiscountSumPlh: "Chegirma (so'm)",
    promoMinAmountPlh: "Min. summa (so'm)",
    promoMaxUsesPlh: 'Maks. foydalanish (0=cheksiz)',
    promoCreateBtn: 'Yaratish',
    colCode: 'Kod',
    colDiscount: 'Chegirma',
    colMinAmount: 'Min summa',
    colUsage: 'Foydalanish',
    colExpiry: 'Muddati',
    colState: 'Holat',
    promoNoCodes: "Promo-kod yo'q",
    promoStatusActive: 'Faol',
    promoStatusInactive: 'Nofaol',
    promoToggleOff: "O'chirish",
    promoToggleOn: 'Yoqish',
    loyaltyPointsTitle: '⭐ Ball hisoblash tartibi',
    loyaltySessionPay: "💰 Sessiya to'lov",
    loyaltyBooking: '📅 Bron',
    loyaltyBirthday: "🎂 Tug'ilgan kun",
    loyaltyReferral: "👥 Do'st taklif",
    loyaltySessionPayDesc: "Har 1000 so'm → 10 ball",
    loyaltyBookingDesc: 'Har bron → 50 ball',
    loyaltyBirthdayDesc: "Tug'ilgan kun hafta → 2x ball",
    loyaltyReferralDesc: 'Yangi foydalanuvchi → 200 ball',
    loyaltyNote: "Balllar avtomatik hisoblanadi. Mobil ilovada mijozlar o'z ballarini ko'radi va balansga almashtirishadi (100 ball = 1000 so'm).",
    allRoomsOption: 'Barcha xonalar uchun',

    // LOGIN
    loginLoggingIn: 'Kirmoqda...',
    loginBtn: 'Kirish →',
    loginOwner: '👑 Egasi',
    loginStaff2: '👤 Xodim',
    loginPassword: 'Parol',
    loginPhone: 'Telefon raqam',
    loginPin: 'PIN kod',
    loginError: 'Xatolik yuz berdi',

    // ACCESS CONTROL
    accessTitle: '🔐 Kirish huquqlari',
    rolesLabel: 'Rollar',
    addNewRole: "Yangi rol qo'shish",
    rolePagesTitle: "roli ko'ra oladigan sahifalar",
    pagesSelected: 'ta sahifa tanlangan',
    selectAllPages: 'Hammasini tanlash',
    clearAllPages: 'Tozalash',
    savedMark: 'Saqlandi ✓',
    savingLabel: 'Saqlanmoqda...',
    selectRoleHint: 'Chapdan rol tanlang',
    staffPinTitle: 'Xodimlar — Kirish PIN i',
    pinSetSuccess: "uchun PIN o'rnatildi",
    setPinFor: "uchun PIN o'rnatish",
    pinMinDigits: 'Kamida 4 ta raqam',
    setPinBtn: "O'rnatish",
    rolePlh: 'menejer, kassir...',

    // THEME
    themeTitle: '🎨 Dizayn & Tema',
    themeSubtitle: "Shell ko'rinishini sozlang — o'zgarishlar kompyuterlarda avtomatik qo'llanadi",
    presetColors: 'Tayyor ranglar',
    customColor: 'Custom rang',
    mainColorLabel: 'Asosiy rang',
    bgColorLabel: 'Fon rangi',
    bgLabel: 'Fon:',
    designStyle: 'Dizayn uslubi',
    classicLabel: 'Klassik',
    classicDesc: "Default ko'rinish",
    glassDesc: 'Shaffof frosted effekt',
    themeSaved: '✓ Saqlandi!',
    livePreview: "Jonli ko'rinish",

    // APPS
    appsTitle: '🚀 Dasturlar katalogi',
    appsSubtitle: "Shell'da ko'rsatiladigan dasturlar — mijoz bosganida avtomatik ishga tushadi",
    appsPresetsBtn: '📋 Tayyor dasturlar',
    appsAddBtn: "+ Dastur qo'shish",
    appsAllFilter: '🚀 Hammasi',
    appsNone: "Dasturlar qo'shilmagan",
    appsNoneHint: '"Tayyor dasturlar" tugmasini bosib Steam, Discord va boshqalarni qo\'shing',
    appColName: 'Nom',
    appColCategory: 'Toifa',
    appColExePath: "Exe yo'li",
    appColOrder: 'Tartib',
    appColStatus: 'Holat',
    appActive: 'Aktiv',
    appHidden: 'Yashirin',
    appSaveRequired: "Nom va exe yo'li majburiy",
    appAddTitle: '+ Yangi dastur',
    appEditTitle: '✏️ Dasturni tahrirlash',
    appNameLabel: 'Dastur nomi *',
    appCategoryLabel: 'Toifa *',
    appIconLabel: 'Ikonka URL (ixtiyoriy)',
    appExeLabel: "Exe yo'li (Windows) *",
    appArgsLabel: 'Argumentlar (ixtiyoriy)',
    appSortLabel: 'Tartib raqami',
    appActiveOption: "Aktiv (ko'rinadi)",
    closeBtn: 'Yopish',
    appAddBtn2: "Qo'shish",
    presetsModalTitle: '📋 Tayyor dasturlar',
    presetsModalHint: "Bosing — avtomatik to'ldiriladi, keyin yo'lni o'zingizga moslab o'zgartiring",
    appCatLauncher: "🎮 O'yin Platformasi",
    appCatCompetitive: '🏆 Kibersport',
    appCatCommunication: '💬 Aloqa',
    appCatSystem: '⚙️ Tizim / Grafika',
    appCatPeripheral: '🖱️ Periferiya',
    appCatStreaming: '📡 Strim',
    appCatBrowser: '🌐 Brauzer',

    // BULK BOOKINGS
    thisWeek: 'Bu hafta',
    bulkTitle: '📅 Bronlar',
    bulkRefresh: '🔄 Yangilash',
    bulkDateRangeLabel: "oralig'i",
    bulkAllTime: '📊 Barcha vaqt',
    bulkStatTotal: 'Jami bronlar',
    bulkStatEarned: 'Daromad',
    bulkStatTodayGroups: 'Bugungi bronlar',
    bulkStatTodayEarned: 'Bugungi daromad',
    bulkAllClubs: 'Barcha klublar',
    bulkAllStatuses: 'Barcha holatlar',
    bulkClearDate: '✕ Sanani tozalash',
    bulkNone: 'Bronlar topilmadi',
    bulkShowing: "Ko'rsatilmoqda",
    bulkSeatsLabel: 'JOYLAR',
    bulkStatusPending: 'Kutmoqda',
    bulkStatusPartialAct: 'Qisman aktiv',
    bulkStatusActive: 'Aktiv',
    bulkStatusCompleted: 'Tugadi',
    bulkStatusExpired: "Muddati o'tdi",
    bulkStatusPartialExp: "Qisman o'tdi",
    bulkStatusCancelled: 'Bekor',
    bulkModeShared: '👥 Umumiy pool',
    bulkModePhone: '📞 Nomer bilan',
    bulkUnknown: "Noma'lum",
    bulkSeatsActiveLabel: 'aktiv',

    // LAUNCHER THEMES
    launcherTitle: '🎨 Launcher dizaynlari',
    launcherCurrentBranch: 'Joriy filial:',
    launcherCurrentDesign: 'Joriy dizayn:',
    launcherComingSoon: 'Tez orada',
    launcherPreviewBtn: "👁 Ko'rish",
    launcherSelectedBtn: '✓ Tanlangan',
    launcherNotReadyBtn: 'Tayyor emas',
    launcherUploadHtml: '⬆ Yangi HTML yuklash',
    launcherCloseBtnLabel: '✕ Yopish',
    launcherNoBranchAlert: "Avval Super Admin → Filialni tanlash dan filial tanlang",
    launcherNotReadyMsg: "hali tayyor emas. Tez orada qo'shiladi.",
    launcherPickedMsg: "tanlandi. Barcha desktop-agentlar 60 soniya ichida avtomatik yangi dizaynga o'tadi.",
    launcherHtmlOnly: 'Faqat .html fayl',
    launcherFileTooLarge: 'Fayl 5MB dan katta',
    launcherUpdatedMsg: "yangilandi. Barcha desktop-agentlar 5 daqiqa ichida yangi versiyani yuklab oladi.",
    launcherSizeLabel: 'Hajmi',
    launcherUploadError: 'Yuklashda xato',
    launcherActiveBadge: '● FAOL',
    launcherSelectBtn: '✓ Tanlash',
    launcherLicense: "Bir martalik litsenziya",
    launcherPaySum: "To'lov summasi",
    launcherPayMethod: "To'lov usulini tanlang",
    launcherPreparing: "⏳ Tayyorlanmoqda...",
    launcherPayVia: "orqali to'lash",
    launcherPayOk: "To'lov qabul qilindi!",
    launcherActivatingMsg: "faollashtirilmoqda...",
    launcherScanQr: "ilovangiz bilan skanerlang",
    launcherAmountLabel: "Summa:",
    launcherQrExpired: "⏰ 10 daqiqa o'tdi — to'lov tasdiqlanmadi.",
    launcherNewQr: "🔄 Yangi QR olish",
    launcherChecking: "To'lov tekshirilmoqda... (ESC — orqaga)",
    launcherOpenBrowser: "🌐 Brauzerda ochish",
    launcherGoBack: "← Orqaga",
    launcherNoConfig: "To'lov tizimi sozlanmagan.",
    launcherNoConfigContact: "Quyidagi raqam orqali murojaat qiling:",
    launcherNavHint: "← → tugmalari bilan almashtiring · ESC yopish",
    launcherNotPurchased: "🔒 Sotib olinmagan",
    launcherNotPurchasedMsg: "Bu dizayn sotib olinmagan",
    launcherBuyBtn: "💳 Sotib olish",
    launcherFree: "BEPUL",
    launcherSelectedBadge: "✓ TANLANDI",
    launcherBranchLabel: "Filial:",
    launcherActiveLabel: "Faol:",
    launcherLoadingPurch: "yuklanmoqda...",
    launcherLoadError: "⚠ Yuklashda xato — qayta urinish",
    launcherPurchasedCount: "Sotib olingan:",
    launcherBuyBadge: "🔒 Sotib oling",
    launcherCloseBtn: "Yopish",
    launcherPurchasedUnit: "ta",
    themeHudDesc: "Esports HUD — notch, magenta+cyan+lime, qiya bosh harf. Real backend bilan to'liq ulangan.",
    themeDesign1Desc: "Toza zamonaviy, PC-xarita urg'usi. Ko'k-teal palitra. ETALON — eng to'liq.",
    themeDesign2Desc: 'Gamifikatsiya — leaderboard, tanga, quest, XP. Binafsha+pushti.',
    themeDesign3Desc: "Konsol uy-ekrani, pastki dock. Ko'k palitra.",
    themeDesign4Desc: 'Chap vertikal menyu, emerald rang. Keng kontent maydoni.',
    themeDesign5Desc: 'Fullscreen afisha + filmstrip navigatsiya. Amber rang.',
    themeDesign6Desc: 'Markazda turnir podium. Crimson palitra. Esports klublar uchun.',
    themeDesign7Desc: "Zich qatorli ro'yxat. Teal rang. Kam joyli klublar uchun.",
    themeDesign8Desc: 'Markazda taymer-yadro + radial tugmalar. Indigo. 1920×1080 uchun.',
    themeDesign9Desc: 'Homiy billboard, reklama-rail. Orange — monetizatsiya. 1920×1080 uchun.',
    themeDesign10Desc: "Monoxrom premium. Oq + yagona lime urg'u. Juda toza.",

    // PAYMENT SETTINGS
    payTitle: "💳 To'lov Sozlamalari",
    paySubtitle: "To'lov provayderlarni sozlash va webhook endpointlarni ko'rish",
    payWarning: "API kalitlar /cybernet/backend/.env faylida saqlanadi. Bu sahifada faqat konfiguratsiya ko'rsatmasi va test funksiyasi mavjud. Kalitlarni to'g'ridan-to'g'ri .env faylga kiriting va serverni qayta ishga tushiring.",
    payStatTotal: "Jami to'lovlar",
    payStatSuccess: 'Muvaffaqiyatli',
    payStatPending: 'Kutilmoqda',
    payStatAmount: 'Jami summa',
    payProviderLabel: 'PROVAYDERLAR',
    payProviderHint: "kartani bosib batafsil ko'ring",
    payEnvExample: '.ENV NAMUNA (backend/.env)',
    payEnvSettings: '.ENV SOZLAMALAR',
    payNoEnvRequired: 'Alohida ENV kalitlar talab qilinmaydi.',
    payWebhookLabel: 'WEBHOOK ENDPOINTLAR',
    payInstructions: "📋 Yo'riqnoma:",
    payCopyBtn: 'Nusxa',
    payConnOk: '✓ Ulanish OK',
    payConnFail: '✗ Xato',
    payLimitsTitle: '⚙️ Umumiy Chegaralar',
    payMinLabel: "Minimal to'lov",
    payMaxLabel: "Maksimal to'lov",
    payConnFailed: "Ulanib bo'lmadi",
    payLimitsAlert: "Chegaralar .env faylida yangilanishi kerak:\n",
    payNotAvailable: 'Hali mavjud emas',
    payDocsInstr: "sahifasidan API kalitlarni oling va /cybernet/backend/.env fayliga qo'shing.",

    // LAB INFO SETTINGS
    labInfoTitle: "📸 Klub ma'lumot va rasmlar",
    labInfoSelectClub: 'Klub tanlash:',
    labInfoDataSection: "Ma'lumotlar",
    labFieldName: 'Nom',
    labFieldAddress: 'Manzil',
    labFieldDesc: 'Tavsif',
    labFieldPhone: 'Telefon',
    labFieldHours: 'Ish vaqti',
    labFieldParentPhone: 'Ota-ona yordam',
    labFieldEmergency: 'Favqulodda tel',
    labMapSection: 'Xarita joyi',
    labMapHint: 'Xarita ustiga bosing yoki markerni sudrab siljiting',
    labSaved: '✅ Saqlandi',
    labCoverChanged: '✅ Cover o\'zgartirildi',
    labPhotosSection: 'Rasmlar galereyasi',
    labUploadPhotos: '📤 Rasm yuklash (bir necha)',
    labPhotoHint: 'JPG/PNG/WEBP · Har biri max 5MB',
    labCurrentCover: '🏆 Hozirgi COVER:',
    labPaySection: '💳 Payme / Click rekvizit',
    labPayDesc: "Karta to'lov aynan sizning Payme/Click hisobingizga tushadi. Biz faqat webhook orqali to'lov qabul qilindimi tekshiramiz — pul o'rtaga tushmaydi. Kiritmagan bo'lsangiz, mijozlar karta bilan to'lay olmaydilar.",
    labPayConfigured: '✓ Sozlangan',
    labPayNotConfigured: '✗ Sozlanmagan',
    labSecretKeySet: "(o'rnatilgan — o'zgartirish uchun yangi kod tering)",
    labSecretKeepBlank: "o'zgarmasa bo'sh qoldiring",
    labNewSecretKey: 'Yangi secret kalit',
    labRemoveClick: "Click ni o'chirish",
    labRemovePayme: "Payme ni o'chirish",
    labSavePayBtn: '💾 Payme/Click rekvizitini saqlash',
    labWebhookNote: '📎 Webhook URL (Payme/Click kabinetiga kiritish):',
    labPhotoCount: 'rasm',
    labConfirmDeletePhoto: "Ushbu rasmni o'chirasizmi?",
    labConfirmRemoveProvider: "rekvizitlarini o'chirasizmi? Ushbu klubda karta orqali to'lov o'chadi.",
    labPaymentSaved: '✅ Payme/Click rekvizit saqlandi',
    labProviderRemoved: "rekvizitlari o'chirildi",

    // FISCAL
    sevenDays: '7 kun',
    thirtyDays: '30 kun',
    fiscalTitle: '🧾 Fiskal KKM',
    fiscalSubtitle: "Online KKM — O'zbekiston Soliq Qo'mitasi talabi",
    fiscalMockBadge: 'Mock rejim',
    tabReceipts: '🧾 Cheklar',
    tabKkmSettings: '⚙️ KKM Sozlamalar',
    tabFiscalStats: '📊 Statistika',
    fiscalSent: 'Yuborildi',
    fiscalPending: 'Kutmoqda',
    fiscalFailed: 'Xato',
    fiscalAllStatuses: 'Barcha holat',
    fiscalNewReceipt: '+ Yangi chek',
    fiscalStatTotal: 'Jami cheklar',
    fiscalStatAmount: 'Jami summa',
    fiscalResend: 'Qayta yuborish',
    fiscalColNumber: 'Chek raqami',
    fiscalColVat: 'QQS (12%)',
    fiscalColDate: 'Sana',
    fiscalNoneFound: 'Cheklar topilmadi',
    fiscalNewReceiptTitle: '🧾 Yangi fiskal chek',
    fiscalAmountPlh: 'Summa',
    fiscalItemNamePlh: 'Mahsulot/xizmat nomi',
    fiscalDefaultItem: 'Kompyuter xizmati',
    fiscalCreateBtn: 'Yaratish',
    fiscalFormRequired: 'Klub va summa kerak',
    fiscalMockWarning: "Mock rejim — haqiqiy Soliq Qo'mitasi API ga ulanilmagan. Cheklar test ma'lumot sifatida saqlanadi. Real integratsiya uchun KKM ID kiriting.",
    fiscalModeLabel: 'Rejim:',
    fiscalRealMode: 'Real KKM',
    fiscalMockMode: 'Mock (test)',
    fiscalFiscalActive: 'Fiskal aktiv',
    fiscalKkmIdLabel: 'KKM ID (ixtiyoriy)',
    fiscalStatVat: 'QQS jami',
    fiscalDailyChart: 'Kunlik cheklar',

    // LAYOUT EDITOR
    layoutTitle: '🗺️ Zal Muharriri',
    layoutSubtitle: 'Xonalarni va PC larni sudrab joylashtiring',
    layoutPlaced: 'joylashtirilgan',
    layoutAddRoom: "+ Xona qo'shish",
    layoutRoomNamePlh: 'Xona nomi...',
    layoutSavedState: '✓ Saqlangan',
    layoutAlertAddRoom: "Avval xona qo'shing",
    layoutAlertNoSpace: 'Xonada joy topilmadi',
    layoutAlertSaveError: 'Saqlashda xatolik',
    layoutConfirmDeleteRoom: "Xonani o'chirasizmi?",
    layoutUnplaced: 'JOYLASHTIRILMAGAN',
    layoutAllPlaced: '✓ Hammasi joylashtirilgan',
    layoutClickTip: '💡 Bosing → birinchi xonaga',
    layoutStatusLabel: 'HOLAT',
    layoutRoomsLabel: 'XONALAR',
    layoutEmptyHint: "+ Xona qo'shish tugmasini bosing",
    layoutStatusAvailable: "Bo'sh",
    layoutStatusBusy: 'Band',
    layoutStatusBroken: 'Buzuq',
    layoutStatusOffline: 'Oflayn',
    layoutTip1: "⠿ Xona headeridan sudrang → butun xona + PC lar ko'chadi",
    layoutTip2: "PC sudrang → ko'chirish (xona avtomatik o'zgaradi)",
    layoutTip3: "↘ Burchak → o'lchamini o'zgartiring",
    layoutTip4: '🖱 Scroll → xarita · Ctrl+Scroll →',
    layoutTip5: '✕ → olib tashlash',
    layoutRenameBtn: "Nomini o'zgartirish",
    layoutColorBtn: "Rangni o'zgartirish",
    layoutDeleteRoomBtn: "Xonani o'chirish",
    // CRM
    crmTitle: '👤 CRM — Mijozlar',
    crmSubtitle: 'Mijozlar bazasi, segmentlar va marketing kampaniyalar',
    crmTabClients: '👥 Mijozlar',
    crmTabSegments: '🎯 Segmentlar',
    crmTabCampaign: '📢 Kampaniya',
    crmSearchPlh: 'Ism yoki telefon...',
    crmAllSegments: 'Barcha segmentlar',
    crmSegAll: 'Barcha foydalanuvchilar',
    crmSeg7d: "Faol (so'nggi 7 kun)",
    crmSeg14d: 'Nofaol (14 kun)',
    crmSeg30d: 'Nofaol (30 kun)',
    crmSeg14dMissed: '14 kun kelmagan',
    crmSeg30dMissed: '30 kun kelmagan',
    crmSegHighBalance: 'Yuqori balanslı',
    crmSegBirthdayToday: "🎉 Bugun tug'ilgan kun",
    crmSegBirthdayMonth: "Tug'ilgan kun bu oy",
    crmColName: 'Ism',
    crmColPhone: 'Telefon',
    crmColBalance: 'Balans',
    crmColSessions: 'Sessiyalar',
    crmColLastVisit: 'Oxirgi kirish',
    crmColSource: 'Manba',
    crmDaysAgo: '{d} kun oldin',
    crmStatBalance: 'Balans',
    crmStatPoints: 'Ball',
    crmStatSessions: 'Sessiyalar',
    crmStatSpent: 'Sarflagan',
    crmBirthday: "Tug'ilgan kun",
    crmSource: 'Manba',
    crmLastSessions: 'Oxirgi sessiyalar',
    crmNotes: 'Izohlar',
    crmAddNote: "Izoh qo'shish...",
    crmSaved: 'Saqlandi',
    crmSegHint: "Segmentga bosing — avtomatik Mijozlar tabiga filter qo'llanadi",
    crmNewCampaign: '📢 Yangi kampaniya',
    crmSegCountFound: '→ {n} ta foydalanuvchi topildi',
    crmBonusLabel: '🎁 Bonus summasi — balanslarga avtomatik tushadi',
    crmBonusPlh: '0 — bonus berilmaydi',
    crmBonusTotalCalc: "Jami: {total} ({n} ta × {amt})",
    crmTitleLabel: 'Sarlavha',
    crmBodyLabel: 'Matn',
    crmPreviewLabel: "📱 Xabar ko'rinishi (namuna)",
    crmNoUsers: "Bu segmentda foydalanuvchi yo'q",
    crmSending: '⏳ Yuborilmoqda...',
    crmSendTo: '📤 {n} ta gamerlarga yuborish',
    crmSentResult: '✅ {n} ta gamerlarga yuborildi',
    crmSentBonus: '· Jami {total} bonus berildi',
    crmCampaignHistory: 'Kampaniya tarixi',
    crmNoCampaigns: "Hali kampaniya yo'q",
    crmHistoryAll: 'Barchasi',
    crmPerPerson: 'kishi',
    crmConfirmTitle: '✅ Tasdiqlash',
    crmConfirmMsg: '{n} ta gamerlarga xabar yuboriladi',
    crmConfirmBonusMsg: "va har biriga {bonus} bonus balanslarga tushadi",
    crmConfirmTotalMsg: "Jami: {total} beriladi. Davom etasizmi?",
    crmConfirmSend: '📤 Ha, yuborish',
    crmTplBirthdayTodayTitle: "🎂 Tug'ilgan kuningiz bilan, {name}!",
    crmTplBirthdayTodayBody: "Tug'ilgan kuningiz bilan tabriklaymiz! {club} game klubidan {amount} so'm sovg'a taqdim etildi. Game klubimizda sovg'angizdan foydalanishingiz mumkin 🎁",
    crmTplInactive14dTitle: "👋 {name}, sizni sog'indik!",
    crmTplInactive14dBody: "14 kundan beri ko'rmadik. Sizni qaytarish uchun {club}dan {amount} so'm bonus tayyorlab qo'ydik. Bugun kelib ko'ring 🎮",
    crmTplInactive30dTitle: "🎮 {name}, bir oylik sovg'a!",
    crmTplInactive30dBody: "Bir oydan beri ko'rmadik! {club} game klubiga qaytishingizni kutib turibmiz — siz uchun {amount} so'm sovg'a tayyorlab qo'ydik 🎮",
    crmTplBirthdayMonthTitle: "🎂 Tug'ilgan kuningiz bilan!",
    crmTplBirthdayMonthBody: "{club}dan tug'ilgan kun sovg'asi: {amount} so'm bonus balansingizga tushirildi. Yaxshi o'yin 🎁",
    crmTplHighBalanceTitle: "💰 Maxsus taklif, {name}!",
    crmTplHighBalanceBody: "{club} sadoqatli mijozlari uchun maxsus bonus: {amount} so'm qo'shimcha qo'shildi. Rahmat!",
    crmTplDefaultTitle: '🎮 {club}dan xabar',
    crmTplDefaultBody: "Hurmatli {name}, {club}dan maxsus taklif: {amount} so'm bonus balansingizga tushirildi!",
    crmSelectSegment: 'Segment tanlang',
    crmSegUsersList: "Ro'yxat",
    crmMoreUsers: 'ta yashirin',
    // Clients
    clientsTotalUsers: "{n} ta ro'yxatdagi foydalanuvchi",
    clientNewBtn: '+ Yangi mijoz',
    clientNotFound: 'Mijozlar topilmadi',
    clientColName: 'Mijoz',
    clientColHours: 'Soatlar',
    clientColPackage: 'Faol paket',
    clientDebt: 'Qarz',
    clientSessionUnit: 'ta',
    clientHourUnit: 'soat',
    clientPackageSuffix: 'paket',
    clientActPackageBtn: '▶ Paket',
    clientTopupBtn: '+ Balans',
    clientPasswordBtn: 'Parol',
    clientAmountPositive: "Summa 0 dan katta bo'lishi kerak",
    clientPassMinChars: 'Parol kamida 4 ta belgi',
    clientSelectPackage: 'Paketni tanlang',
    clientCreateTitle: '👤 Yangi mijoz yaratish',
    clientFieldFullName: 'ISM VA FAMILIYA',
    clientFieldPhone: 'TELEFON RAQAM',
    clientFieldPassword: 'PAROL (ilovaga kirish uchun)',
    clientFieldInitBalance: "BOSHLANG'ICH BALANS (ixtiyoriy)",
    clientPassMinCharsPlh: 'Kamida 4 ta belgi',
    clientCreateBtn: '✓ Yaratish',
    clientTopupTitle: "💰 Balans to'ldirish",
    clientInfoName: 'Mijoz:',
    clientInfoPhone: 'Telefon:',
    clientInfoBalance: 'Joriy balans:',
    clientTopupAmountLabel: "TO'LDIRISH SUMMASI",
    clientTopupAsDebt: "Qarz sifatida qo'shish",
    clientTopupDebtNote: 'Mijoz seans tugaganda qizil ogohlantirish ko\'radi',
    clientPayDebtTitle: "💸 Qarz to'lash",
    clientTotalDebt: 'Jami qarz:',
    clientPayAmountLabel: "TO'LOV SUMMASI",
    clientPayDebtFull: "To'liq",
    clientPayAccepted: "qabul qilindi",
    clientPasswordTitle: "🔑 Parol o'zgartirish",
    clientNewPasswordLabel: 'YANGI PAROL',
    clientNewPasswordPlh: 'Yangi parol kiriting',
    clientDebtUnpaid: "to'lanmagan",
    clientPayDebtBtn: "💸 To'lash",
    clientTotalSessions: 'Jami sessiyalar:',
    clientTotalSpent: 'Jami sarf:',
    clientRegistered: "Ro'yxatdan:",
    clientActivatePackage: '▶ Paket aktivlashtirish',
    clientPasswordBtnShort: '🔑 Parol',
    clientLastSessions: "SO'NGGI SESSIYALAR",
    clientNoSessions: "Sessiyalar yo'q",
    clientHourly: 'Soatlik',
    clientCloseBtn: 'Yopish',
    clientActivatePackageTitle: '▶ Paket aktivlashtirish',
    clientVoucherCreated: 'Voucher yaratildi!',
    clientVoucherInst1: "Mijoz istalgan bo'sh PCga borib",
    clientVoucherInst2: 'login va parolini kiritsin',
    clientVoucherInst3: 'sessiya avtomatik boshlanadi',
    clientInfoPackage: 'Paket:',
    clientInfoDuration: 'Davomiylik:',
    clientInfoPaid: "To'landi:",
    clientInfoRemainingBalance: 'Qolgan balans:',
    clientInfoValidFor: 'Amal qiladi:',
    clientMinuteUnit: 'daqiqa',
    clientMinShort: 'daq',
    clientHourShort: 's',
    clientHourFull: 'soat',
    clientRoomLabel: 'XONA',
    clientSelectRoom: 'Xona tanlang...',
    clientSelectPackageLabel: 'PAKET TANLANG',
    clientNoPackages: "Bu xonada faol paket yo'q",
    clientInsufficientBalance: '⚠ Balans yetarli emas',
    clientActivateHint: "💡 To'lovdan keyin mijoz istalgan bo'sh PCga borib login/parolini kiritadi — sessiya avtomatik boshlanadi",
    clientActivateBtn: "💳 To'lab aktivlashtirish",
    clientPackagesTitle: 'Paketlar',
    clientVoucherWaiting: 'Kutmoqda',
    clientVoucherRemaining: 'Qoldi:',
    clientVoucherTotalRemaining: 'Jami qolgan vaqt:',

    // SNACK POS
    snackTitle: '🍕 Snack-bar POS',
    snackSubtitle: 'Bufet / ichimlik sotuvi',
    snackShiftOpen: '● Smena ochiq · ⏹ Yopish',
    snackShiftClosed: '○ Smena yopiq · ▶ Ochish',
    snackCompOrderOn: '✓ Komp-buyurtma yoqilgan',
    snackCompOrderOff: "○ Komp-buyurtma o'chirilgan",
    snackCompOrderOnHint: 'Foydalanuvchilar buyurtma berishi mumkin (komp ichidan)',
    snackCompOrderOffHint: "Buyurtma berish o'chiq — komp ichida tugma yashiringan",
    snackTabPos: '🛒 Kassa',
    snackTabOrders: 'Ochiq',
    snackTabSmena: 'Smena',
    snackTabProducts: 'Mahsulotlar',
    snackTabCats: 'Kategoriyalar',
    snackTabShortage: 'Kamomad',
    snackTabStats: 'Statistika',
    snackCategoryLabel: 'Kategoriya',
    snackPickCategory: 'Kategoriya tanlang',
    snackCategoryRequired: '⚠ Kategoriya tanlanishi majburiy — launcher va mobil ilovada mahsulot kategoriya bo\'yicha filterlanadi',
    snackNoCategory: 'Kategoriya yo\'q',
    snackAddEmojiLabel: 'Emoji (mahsulot ikoni)',
    snackCatHelp: 'Kategoriyalar launcher va mobil ilovada ko\'rinadi. UZ nomi majburiy, RU nomi tavsiya etiladi — rus tilidagi foydalanuvchi ko\'rishi uchun.',
    snackCatAddTitle: 'Yangi kategoriya qo\'shish',
    snackCatNameUzPlh: 'Nomi (O\'zbek) *',
    snackCatNameRuPlh: 'Название (Русский)',
    snackCatNameRequired: 'Kategoriya nomi majburiy',
    snackCatProductsSuffix: 'mahsulot',
    snackCatDeleteConfirm: '"{name}" kategoriyasini o\'chirishni xohlaysizmi? Mahsulotlar o\'chmaydi, lekin kategoriyasiz qoladi.',
    snackCatEmpty: 'Kategoriyalar yo\'q. Yuqoridagi formadan qo\'shing.',
    snackBarcodePlh: 'Barkod skanerlang yoki yozing...',
    snackNotFound: 'Topilmadi',
    snackAllCats: 'Barchasi',
    snackStockLeft: 'Qoldi:',
    snackNoProducts: "Mahsulot yo'q",
    snackCart: '🛒 Savat',
    snackPickProduct: 'Mahsulot tanlang',
    snackPcPlh: 'PC raqami (ixtiyoriy)',
    snackPayCash: '💵 Naqd',
    snackPayTerminal: '💳 Terminal',
    snackDebtOn: '🔴 Qarz sifatida (belgilandi)',
    snackDebtOff: '+ Qarz sifatida belgilash',
    snackDebtUserPlh: 'Mijoz ismi yoki telefon...',
    snackSearching: 'Qidirilmoqda...',
    snackDebtUserRequired: '* Mijozni tanlash majburiy',
    snackDebtLabel: '(qarz)',
    snackSaveDebt: '🔴 Qarz sifatida saqlash',
    snackSell: '✅ Sotish',
    snackClear: 'Tozalash',
    snackSoldFlash: '✅ Sotildi!',
    snackNoOpenOrders: "Ochiq buyurtma yo'q",
    snackDebtBadge: '🔴 QARZ',
    snackPaid: "To'langan ✓",
    snackOpenShiftTitle: '▶ Yangi smena ochish',
    snackAdminLabel: 'Admin *',
    snackSelectAdmin: '— Adminni tanlang —',
    snackAdminPlh: 'Admin ismi...',
    snackNoStaff: "⚠ Xodimlar qo'shilmagan.",
    snackGoStaffPage: "Staff sahifasiga o'ting",
    snackOrManual: "yoki ismni qo'lda kiriting.",
    snackOpenCashLabel: "Kassadagi boshlang'ich pul (so'm)",
    snackOpenBtn: '▶ Ochish',
    snackCloseShiftTitle: '⏹ Smenani yopish',
    snackInfoAdmin: '👤 Admin:',
    snackInfoOpened: '🕐 Ochildi:',
    snackInfoOpenCash: "💵 Boshlang'ich:",
    snackInfoOrders: '📋 Buyurtmalar:',
    snackInfoRevenue: '💰 Smena tushumi:',
    snackOrderCountFmt: '{n} ta',
    snackCloseCashLabel: "Kassadagi yakuniy pul (so'm) *",
    snackDiff: 'Farq:',
    snackExpected: 'kutilgan:',
    snackCloseBtn: '⏹ Yopish',
    pinLabel: 'PIN kod',
    pinRequired: 'PIN kod kiriting',
    pinMin4: 'PIN kamida 4 ta raqam',
    pinPlh: '4+ ta raqam',
    pinLeaveBlank: "bo'sh qoldirsangiz o'zgarmaydi",
    snackPinChangeTitle: 'Yangi PIN kiriting',
    snackPinEnterTitle: 'PIN kod kiriting',
    snackPinEmpty: "PIN bo'sh bo'lmasin",
    snackPinChanged: "PIN o'zgartirildi ✓",
    snackPinWrong: "Noto'g'ri PIN",
    snackPinSave: 'Saqlash',
    snackPinLogin: 'Kirish',
    snackChangePin: "🔑 PIN o'zgartirish",
    snackLock: '🔒 Qulflash',
    snackAddProduct: "+ Mahsulot qo'shish",
    snackNamePlh: 'Nomi *',
    snackPricePlh: "Narxi (so'm) *",
    snackCostPlh: "Tannarxi (so'm)",
    snackStockPlh: 'Qoldiq (dona)',
    snackBarcodePlhAdd: "🔍 Barkod (ixtiyoriy) — skanerlab kiriting yoki qo'lda yozing",
    snackImgChange: "O'zgartirish",
    snackImgAdd: "Rasm qo'shish",
    snackImgDeleteConfirm: "Rasmni o'chirish?",
    snackAutoFindPhoto: "Avto",
    snackAutoFindPhotoHint: "Open Food Facts'dan avtomatik rasm topish",
    snackAutoFindPhotoConfirm: "Hozirgi rasm almashtiriladi. Davom etamiz?",
    snackAutoFindPhotoLoading: "Qidiryapti...",
    snackAutoFindPhotoError: "Rasm topilmadi",
    snackProductActive: 'Faol',
    snackProductInactive: 'Nofaol',
    snackStockDona: 'Qoldi: {n} dona',
    snackUploadError: 'Yuklashda xato',
    snackShiftOpenStatus: '● SMENA OCHIQ',
    snackShiftClosedStatus: '○ SMENA YOPIQ',
    snackSmenaRevenue: '💰 Tushum:',
    snackSmenaReturns: '↩ Qaytarish:',
    snackNoShift: 'Smena ochilmagan. Yangi smena boshlash uchun tugmani bosing.',
    snackRefresh: '🔄 Yangilash',
    snackCloseShiftBtn: '⏹ Smenani yopish',
    snackOpenShiftBtn: '▶ Smena ochish',
    snackShiftOrdersTitle: 'Buyurtmalar istoriyasi ({n})',
    snackNoOrdersYet: "Hali buyurtma yo'q",
    snackShiftHistoryTitle: 'Smena tarixi',
    snackShiftHistoryEmpty: "Hali yopilgan smena yo'q",
    snackOrdersLabel: 'ta buyurtma',
    snackEditProduct: 'Tahrirlash',
    snackCostLabel: 'Tannarx',
    snackAlertName: 'Mahsulot nomi kerak',
    snackAlertPrice: "Narx noto'g'ri",
    snackReturnSelectTitle: 'Qaysi buyurtmadan qaytarish?',
    snackNoReturnableOrders: "To'langan buyurtma topilmadi",
    snackDebtOrderBadge: '🔴 QARZ',
    snackReturnBtn: '↩ Qaytarish',
    snackReturnTitle: '↩ Qaytarish — buyurtma #{n}',
    snackSoldInfo: "Sotilgan: {qty} ta · {price} so'm/ta",
    snackReturnQtyLabel: 'Qaytarish:',
    snackReturnTotal: 'Qaytariladigan summa:',
    snackReturnReasonPlh: 'Sabab (ixtiyoriy)',
    snackReturnConfirm: '↩ Qaytarishni tasdiqlash',
    snackInvHistory: '📋 Tarix',
    snackInvNew: '📝 Yangi hisoblash',
    snackInvEmpty: "Hali inventarizatsiya o'tkazilmagan",
    snackShortageCount: '{n} ta mahsulot — {total} dona kamomad',
    snackNoShortage: "✓ Kamomad yo'q",
    snackInvColProduct: 'Mahsulot',
    snackInvColExpected: 'Kutilgan',
    snackInvColActual: 'Haqiqiy',
    snackInvColDiff: 'Farq',
    snackKamomad: 'KAMOMAD',
    snackInvHint: "Haqiqiy sondagi raqamlarni kiriting. Saqlangandan so'ng tizim qoldig'i yangilanadi.",
    snackInvColSystem: 'Tizimda bor',
    snackInvColInput: 'Haqiqatda (kiriting)',
    snackInvNotePlh: 'Izoh (ixtiyoriy, masalan: kechki smena, Sarvar)',
    snackInvSave: '💾 Saqlash',
    snackStatsTodayOrders: 'Bugungi buyurtmalar',
    snackStatsTodayRevenue: 'Bugungi tushum',
    snackStatsOpenOrders: 'Ochiq buyurtmalar',
    snackTopProducts: 'Top mahsulotlar (bugun)',
    snackDona: 'dona',
    snackAlertAdminName: 'Admin ismini kiriting',
    snackAlertReturnSelect: 'Qaytariladigan mahsulot tanlang',
    snackAlertDebtUser: 'Qarz uchun mijozni tanlang',

    // SUPER ADMIN
    superAdminSubtitle: 'Barcha filiallar boshqaruvi',
    superTabSelect: '🎯 Filialni tanlash',
    superTabAnalytics: '📊 Analitika',
    superTabOwners: '🏢 Filiallar',
    superTabMenu: '📑 Menyu tartibi',
    superStatusTrial: 'Sinov',
    superStatusActive: 'Faol',
    superStatusExpired: "Muddati o'tgan",
    superStatusCancelled: 'Bekor',
    superPeriodToday: 'Bugun',
    superPeriodWeek: 'Hafta',
    superPeriodMonth: 'Oy',
    superPeriodYear: 'Yil',
    superPeriodCustom: 'Boshqa',
    superThCash: 'Naqd',
    superThTerminal: 'Terminal',
    superThClick: 'Click',
    superThPayme: 'Payme',
    superThRevenue: 'Jami',
    superBtnView: "Ko'rish",
    superTotalIncome: 'Jami daromad',
    superSessionIncome: 'Sessiya daromad',
    superTotalExpenses: 'Jami xarajat',
    superNetProfit: 'Sof foyda',
    superByBranchAnalysis: "Filiallar bo'yicha tahlil",
    superThBranchName: 'Filiyal nomi',
    superThSnackIncome: 'Snack daromad',
    superUnitPcs: 'ta',
    superTooltipDetails: 'Batafsil',
    superTotalRow: 'JAMI',
    superAllBranches: 'Barcha filiallar',
    superStatTotalOwners: 'Jami egalar',
    superStatActiveSubscriptions: 'Faol obunalar',
    superStatTrialPeriod: 'Sinov davri',
    superStatTotalComputers: 'Jami kompyuterlar',
    superThOwner: 'Ega',
    superThPlan: 'Reja',
    superThStatus: 'Holat',
    superThExpires: 'Tugaydi',
    superThActions: 'Amallar',
    superNoPlan: 'Rejasiz',
    superDayAbbr: 'k',
    superBtnAssign: 'Belgilash',
    superDetailExpenses: '💸 Xarajatlar',
    superDetailSnack: '🍕 Snack daromad',
    superDetailSessions: '🎮 Sessiya daromad',
    superBtnClose: '✕ Yopish',
    superBtnBack: '← Orqaga',
    superThDate: 'Sana',
    superThDescription: 'Tavsif',
    superThAmount: 'Summa',
    superThProduct: 'Mahsulot',
    superThQty: 'Dona',
    superThPackage: 'Paket',
    superThSessions: 'Sessiya',
    superThClient: 'Mijoz',
    superNoExpenses: "Xarajat yo'q",
    superRecordsCount: 'ta yozuv',
    superTotalSnackIncome: 'Jami snack daromad',
    superSnackProductsHeading: '🛒 Nimalar sotilgan',
    superNoData: "Ma'lumot yo'q",
    superByBranchHeading: "📍 Filiyal bo'yicha",
    superOrdersCount: 'ta buyurtma',
    superSessionsCount: 'ta sessiya',
    superTotalSessionIncome: 'Jami sessiya daromad',
    superByPackageHeading: '📦 Qaysi paketdan pul tushgan',
    superNoPackage: 'Paketsiz',
    superNoSessions: "Sessiya yo'q",
    superRecentSessions: "🕐 So'nggi sessiyalar",
    superGuestName: 'Mehmon',
    superStatusEnded: 'Tugagan',
    superModalSubTitle: 'Obuna belgilash',
    superModalSubFor: '{name} uchun obuna',
    superLabelPlan: 'REJA',
    superLabelDuration: 'MUDDAT',
    superLabelNote: 'IZOH',
    superMonthAbbr: 'oy',
    superUnlimited: 'cheksiz',
    superPlaceholderOptional: 'Ixtiyoriy...',
    superNoLabsFound: 'Sizga tegishli filiallar topilmadi.',
    superMsgActiveBranch: '📍 Faol filial: {name}',
    superSelectLabTitle: '🎯 Faol filial',
    superSelectLabHint: "Filialni bosing — barcha sahifalardagi ma'lumotlar shu filialga moslab ko'rsatiladi.",
    superBadgeActive: '✓ FAOL',
    superAvailableSuffix: "bo'sh",
    superPerHour: 'soat',
    superMsgSubSet: '✅ {name} uchun obuna belgilandi',
    superConfirmCancel: '{name} uchun obunani bekor qilmoqchimisiz?',
    superMsgSubCancelled: '{name} obunasi bekor qilindi',
    superMsgMenuSaved: '✅ Menyu tartibi saqlandi. Sahifani yangilang.',
    superMsgMenuReset: '↺ Asl tartibga qaytarildi.',
    superMenuOrderTitle: '📑 Yon panel tartibini sozlash',
    superMenuOrderHint: "Sahifalarni tortib joylashtiring yoki ↑ ↓ tugmalari bilan o'rin almashtiring. O'zgartirishlar faqat shu brauzerda saqlanadi.",
    superBtnSave: '💾 Saqlash',
    superBtnResetOrder: '↺ Asl tartib',
    superErrorLoading: 'Yuklashda xatolik',
  },

  ru: {
    // NAV
    dashboard: 'Панель',
    floor: 'Зал',
    kassa: 'Касса',
    obuna: 'Подписка',
    superAdmin: 'Супер Админ',
    computers: 'Компьютеры',
    packages: 'Пакеты',
    sessions: 'Сессии',
    bookings: 'Брони',
    logout: 'Выход',

    // NAV — все страницы
    nav_dashboard: 'Панель',
    nav_floor: 'Зал',
    nav_kassa: 'Касса',
    nav_bar_preorders: 'Заказы бара',
    nav_sessions: 'Сессии',
    nav_bookings: 'Брони',
    nav_clients: 'Клиенты',
    nav_announcements: 'Новости & Скидки',
    nav_feedbacks: 'Жалобы/Предложения',
    nav_notifications: 'Уведомления',
    nav_finance: 'Финансы & Аналитика',
    nav_expenses: 'Расходы',
    nav_staff: 'Сотрудники & Зарплата',
    nav_crm: 'CRM',
    nav_snack: 'Снек-бар',
    nav_promotions: 'Акции',
    nav_topup_bonuses: 'Бонус при пополнении',
    nav_promo: 'Промо / Лояльность',
    nav_memberships: 'Абонемент & ЧЧ',
    nav_tournaments: 'Турниры',
    nav_refunds: 'Возврат',
    nav_rewards: 'Призы',
    nav_leaderboard: 'Лидерборд',
    nav_games: 'Игры',
    nav_apps: 'Каталог программ',
    nav_packages: 'Пакеты',
    nav_computers: 'Компьютеры',
    nav_maintenance: 'Техобслуживание',
    nav_lab_info: 'Данные клуба',
    nav_layout_editor: 'Редактор зала',
    nav_launcher_themes: 'Темы лаунчера',
    nav_payment_settings: 'Настройки оплаты',
    nav_fiscal: 'Фискальный ККМ',
    nav_access_control: 'Права доступа',
    nav_theme: 'Дизайн & Тема',
    nav_obuna: 'Подписка',
    nav_super_admin: 'Супер Админ',

    // DASHBOARD
    greeting: 'Привет',
    todayStatus: 'Сегодняшний статус',
    todayUsers: 'Клиентов сегодня',
    activeSessions: 'Занятых компьютеров',
    todayIncome: 'Доход сегодня',
    available: 'Свободно',
    revenueChart: 'График дохода',
    last7days: 'Последние 7 дней',
    last30days: 'Последние 30 дней',
    topComputers: 'Топ компьютеры (30 дней)',
    noData: 'Нет данных',
    sum: 'сум',
    sessions_: 'сессий',
    loading: 'Загрузка...',

    // BOOKINGS
    allBookings: 'Все брони',
    pending: 'Ожидает',
    confirmed: 'Подтверждён',
    cancelled: 'Отменён',
    completed: 'Завершён',
    confirm: 'Подтвердить',
    cancel: 'Отменить',
    user: 'Пользователь',
    lab: 'Зал',
    package: 'Пакет',
    scheduledAt: 'Время',
    status: 'Статус',
    actions: 'Действия',

    // SESSIONS
    allSessions: 'Все сессии',
    active: 'Активные',
    computer: 'Компьютер',
    started: 'Начало',
    ends: 'Конец',
    paid: 'Оплачено',
    guest: 'Гость',

    // COMMON
    refresh: 'Обновить',
    close: 'Закрыть',
    save: 'Сохранить',
    yes: 'Да',
    no: 'Нет',
    error: 'Ошибка',
    success: 'Успешно',
    somPerMonth: 'сум/мес',
    add: 'Добавить',
    edit: 'Изменить',
    delete: 'Удалить',
    search: 'Поиск',
    filter: 'Фильтр',
    export: 'Экспорт',
    print: 'Печать',
    send: 'Отправить',
    total: 'Итого',
    name: 'Имя',
    phone: 'Телефон',
    date: 'Дата',
    amount: 'Сумма',
    balance: 'Баланс',
    type: 'Тип',
    description: 'Описание',
    owner: 'Владелец',
    staff: 'Сотрудник',
    noItems: 'Нет данных',
    back: 'Назад',

    // KASSA & SMENA
    kassaTitle: '💰 Касса & Смена',
    shiftOpen: 'Смена открыта',
    shiftClosed: 'Смена закрыта',
    openShift: 'Открыть смену',
    closeShift: 'Закрыть смену',
    shiftHistory: 'История смен',
    noShifts: 'Смен нет',
    xReport: '📋 X-Отчёт',
    zReport: '🧾 Z-Отчёт',
    openShiftBtn: '🔓 Открыть смену',
    closeShiftBtn: '🔒 Z-Отчёт + Закрыть',
    xReportInterim: '📋 X-Отчёт (промежуточный)',
    zReportFinal: '🧾 Z-Отчёт (итоговый)',
    shiftOpened: 'Смена открыта',
    shiftClosed2: 'Смена закрыта',
    cashRegister: 'Нал. касса',
    expectedCash: 'Ожидаемый нал',
    actualCash: 'Фактический нал',
    openingCash: 'Начальный нал',
    cashShortage: 'Недостача / Излишек',
    sessionRevenue: 'Доход сессий',
    snackRevenue: 'Доход снек-бара',
    totalRevenue: 'Общий доход',
    sessionsCount: 'Кол-во сессий',
    newClients: 'Новые клиенты',
    cashInRegister: 'Нал в кассе',
    cashInRegisterLabel: 'Наличные',
    cardPayment: 'Карта',
    balancePayment: 'С баланса',
    cashPayment: 'Наличные',
    action_session_start: 'Сессия начата',
    action_session_end: 'Сессия завершена',
    action_session_force_end: 'Принудительно остановлена',
    action_walkin_start: 'Walk-in сессия',
    action_walkin_stop: 'Walk-in остановлен',
    action_topup_test: 'Тестовый платёж',
    action_topup_click: 'Платёж Click',
    action_topup_payme: 'Платёж Payme',
    action_shift_open: 'Смена открыта',
    action_shift_close: 'Смена закрыта',
    action_expense_add: 'Расход добавлен',
    operator: 'Оператор',
    opened: 'Открыта',
    closed: 'Закрыта',

    // ZAL (FLOOR)
    floorTitle: '🖥️ Управление залом',
    statusAvailableFloor: 'Свободно',
    statusBusyFloor: 'Занято',
    statusBrokenFloor: 'Сломан',
    statusBooked: 'Бронь',
    statusOffline: 'Выкл',
    statusMaintenance: 'Техник',
    startSession: 'Начать сессию',
    endSession: 'Завершить',
    addTime: 'Добавить время',
    selectPackage: 'Выберите пакет',
    selectUser: 'Пользователь',
    enterPhone: 'Номер телефона',
    guestEntry: 'Вход гостя',
    minsLeft: 'мин осталось',
    hoursShort: 'ч',
    minsShort: 'м',
    realLayout: '🗺️ Реальное расположение',
    floorBusy: 'занято',
    floorFree: 'свободно',
    floorTotal: 'всего PC',
    sessionOpenTitle: 'Открыть сессию',
    manageTitle: 'Управление',
    packagedMode: '📦 По пакету',
    hourlyMode: '⏱️ Почасовой',
    phoneOptional: 'НОМЕР ТЕЛЕФОНА (опционально)',
    balanceLabel: 'Баланс',
    guestNamePlaceholder: 'Имя (наличный клиент)...',
    timedSessionInfo: '⏱️ Почасовой расчёт — оплата при остановке сессии',
    packageLabel: 'ПАКЕТ',
    minutesShort: 'мин',
    roomNotAllowed: 'не для этого зала',
    allRooms: 'все залы',
    noPackagesFound: 'Пакетов не найдено',
    continueFromBalance: 'После пакета продолжить с баланса',
    paymentTypeLabel: 'ТИП ОПЛАТЫ',
    cashOption: '💵 Наличные',
    cardOption: '💳 Карта',
    balanceOption: '📱 Баланс приложения',
    startBtn: '▶ Начать',
    cancelShort: 'Отмена',
    addTopupTitle: '💰 ПОПОЛНИТЬ БАЛАНС',
    topupSuccess: '✓ Успешно отправлено!',
    receiveMoneyLabel: '💵 ПРИНЯТО — ДОБАВИТЬ ВРЕМЯ',
    amountPlaceholder: 'Сумма (сум)...',
    addMinutesBtn: 'мин добавить',
    enterAmount: 'Введите сумму',
    priceNotFound: '⚠️ Данные о цене не найдены',
    moveToPC: 'ПЕРЕНЕСТИ НА ДРУГОЙ PC',
    selectPCPlaceholder: 'Выберите PC...',
    moveBtn: 'Перенести',
    remoteControl: 'УДАЛЁННОЕ УПРАВЛЕНИЕ',
    stopSessionBtn: '⏹ Остановить сессию',
    clientLabel: 'Клиент',
    packageField: 'Пакет',
    timeLeftLabel: 'Осталось',
    paidLabel: 'Оплачено',
    typeField: 'Тип',
    timedType: '⏱️ Почасовой',
    elapsedLabel: 'Прошло времени',
    pricePerHour: 'сум/час',
    payTypeLabel: 'Тип оплаты',
    cashLabel: 'Наличные',
    cardLabel: 'Карта',
    appBalanceLabel: 'Баланс приложения',
    onlineTag: 'включён',
    offlineTag: 'выключен',
    timedMode: '⏱️ Почасовой',
    manageBtn: '⚙ Управлять',
    freeSessionBtn: '+ Открыть сессию',
    freeStartBtn: '+ Начать',
    pcOnline: 'Включён',
    pcOffline: 'Выключен',
    emptyPC: 'Этот PC сейчас свободен.',
    manageArrow: 'Управление →',
    turnOnBtn: '⚡ Включить (Wake-on-LAN)',
    turnOffBtn: '⏻ Выключить',
    openSessionAction: '▶ Открыть сессию',
    addBookingAction: '🔖 Добавить бронь',
    maintenanceActivate: '✓ Тех. работы завершены — Активировать',
    maintenanceSet: '🔧 Отправить на техобслуживание',
    bookTitle: 'Добавить бронь',
    guestNameLabel: 'ИМЯ КЛИЕНТА (опционально)',
    guestNamePlh: 'Имя или фамилия...',
    phoneWithLookup: 'ТЕЛЕФОН (опционально — ищет в базе)',
    dateLabel2: 'ДАТА',
    fromTimeLabel: 'С (время)',
    toTimeLabel: 'ДО (опционально)',
    packageOptional: 'ПАКЕТ (опционально)',
    withoutPackage: '— Без пакета —',
    bookAction: '🔖 Забронировать',
    warningTimeEnding: 'Время заканчивается!',
    addTimeOrTopup: 'Добавьте время или пополните баланс пользователя',
    guestCash: 'Наличный клиент',

    // FINANCE
    financeTitle: 'Финансы & Аналитика',
    revenue: 'Доход',
    expenses: 'Расходы',
    profit: 'Прибыль',
    profitLoss: 'Прибыль / Убыток',
    topCustomers: 'Топ клиенты',
    byComputer: 'По компьютеру',
    debtors: 'Должники',
    suspiciousActivity: 'Подозрительная активность',
    snackSales: 'Продажи бара',
    totalSales: 'Всего продаж',
    margin: 'Прибыль',
    noSnackSales: 'Продаж бара нет',
    noTopup: 'Пополнений нет',
    noSessions: 'Сессий не было',
    normal: 'Работает нормально',
    noAnomalies: 'Аномалий не обнаружено',

    // PACKAGES
    packagesTitle: '📦 Пакеты',
    addPackage: 'Добавить пакет',
    editPackage: 'Изменить пакет',
    packageName: 'Название пакета',
    price: 'Цена',
    duration2: 'Длительность',
    duration: 'Длительность (мин)',
    type_time: 'Время',
    type_night: 'Ночной',
    type_hourly: 'Почасовой',
    noPackages: 'Пакетов нет',

    // COMPUTERS
    computersTitle: '🖥️ Компьютеры',
    addComputer: 'Добавить компьютер',
    editComputer: 'Изменить компьютер',
    computerNumber: 'Номер',
    computerSpec: 'Характеристики',
    noComputers: 'Компьютеров нет',

    // CLIENTS / CRM
    clientsTitle: '👥 Клиенты',
    allClients: 'Все клиенты',
    totalSpent: 'Всего потрачено',
    totalSessions: 'Сессии',
    lastVisit: 'Последний визит',
    registered: 'Зарегистрирован',
    addNote: 'Добавить заметку',
    noNotes: 'Заметок нет',
    sendBonus: 'Отправить бонус',
    sendPush: 'Push-уведомление',

    // STAFF
    staffTitle: '👥 Сотрудники',
    salary: 'Зарплата',
    salaryHistory: 'История зарплат',
    paySalary: 'Выдать зарплату',

    // FINANCE tabs
    tab_topup: 'Пополнения',
    tab_snack: 'Снек',
    tab_sessions: 'Сессии',
    tab_shifts: 'Смены',
    tab_expenses: 'Расходы',
    tab_debtors: 'Должники',
    tab_anomalies: 'Аномалии',
    tab_all: 'Все',

    // NOTIFICATIONS
    notificationsTitle: '🔔 Уведомления',
    sendNotification: 'Отправить уведомление',
    allUsers: 'Все пользователи',
    titleLabel: 'Заголовок',
    bodyLabel: 'Текст',
    fcmConnected: '🟢 Firebase подключён',
    fcmNotConfigured: '🔴 Firebase не настроен',
    fcmWarningTitle: '⚠️ Firebase не настроен',
    tabBroadcast: '📢 Рассылка',
    tabComputer: '🖥️ Компьютер',
    tabHistory: '📋 История',
    tabTest: '🧪 Тест',
    broadcastSendTitle: 'Отправить рассылку',
    titlePlhNotif: 'Например: Новая акция!',
    bodyPlhNotif: 'Текст уведомления...',
    sendBtn: '📢 Отправить',
    broadcastFootnote: 'Будет отправлено всем пользователям, у которых были сессии или брони в последние 30 дней.',
    templatesTitle: '📋 Готовые шаблоны',
    refreshBtn: '🔄 Обновить',
    noNotifications: 'Уведомлений нет',
    pcMsgTitle: 'Сообщение компьютеру',
    pcMsgDesc: 'Сообщение немедленно появится на экране компьютера (если агент запущен).',
    pcSelectLabel: 'Компьютер',
    pcMsgLabel: 'Текст сообщения',
    pcMsgPlh: 'Например: Клуб закрывается через 5 минут...',
    quickMsgsTitle: 'Быстрые сообщения',
    sentMsgsTitle: 'Отправленные сообщения',
    noMsgsSent: 'Сообщений ещё не отправлено',
    msgSeen: 'Просмотрено',
    msgPending: '⏳ Ожидает',
    sendToPcBtn: '🖥️ Отправить на компьютер',
    testTitle: 'Тестовое уведомление',
    testDesc: 'Введите FCM-токен устройства пользователя — можно взять из консоли браузера или Flutter debug log.',
    fcmTokenLabel: 'FCM Token',
    fcmTokenPlh: 'fcm token (длинная строка)...',
    sendTestBtn: '🧪 Отправить тест',
    fcmNotConfiguredTest: 'Firebase не настроен — тест отправить невозможно',
    newBadge: 'Новое',
    pcBusy: 'Занят',
    pcFree: 'Свободен',

    // PROMOTIONS
    promotionsTitle: '🎯 Акции / Скидки',
    addPromotion: '+ НОВАЯ АКЦИЯ',
    noPromotions: 'Акций пока нет',
    noPromotionsHint: 'Нажмите "+ НОВАЯ АКЦИЯ" чтобы создать',
    statusActivePromo: 'АКТИВНА',
    statusInactive: 'НЕАКТИВНА',
    expiresOn: 'Истекает',
    unlimited: 'Бессрочно',
    editItem: 'ИЗМЕНИТЬ',
    editPromotion: 'Редактировать акцию',
    newPromotion: 'Новая акция',
    descLabel: 'Описание',
    expiresAtLabel: 'Дата окончания',
    imageUrlLabel: 'URL изображения (необязательно)',
    activeLabel: 'Активна',
    alertTitleRequired: 'Введите заголовок',
    confirmDeletePromo: 'Удалить акцию?',
    promotionsSubtitle: 'Видно в разделе "Скидки" мобильного приложения',
    clubNotSelected: 'Выберите клуб',

    // COMPUTERS
    computersPageTitle: 'Компьютеры',
    pcCount: 'компьютеров',
    addPc: '+ Добавить PC',
    noPcs: 'Компьютеров нет. Нажмите "+ Добавить PC".',
    statusAvailable: 'Свободен',
    statusBusy: 'Занят',
    statusBroken: 'Сломан',
    autoShutdown: 'Автоотключение',
    autoShutdownDesc: 'Если ПК простаивает после сессии, он автоматически выключается. Экономия электричества.',
    enabled: 'Включено',
    disabled: 'Отключено',
    saving: 'Сохранение...',
    idleTime: 'Время простоя:',
    min: 'мин',
    bookingDeposit: 'Залог за бронь',
    bookingDepositDesc: 'Сумма залога при бронировании. Не возвращается при неявке. 0 — залога нет.',
    currency: 'сум',
    currentDeposit: 'Текущий:',
    addPcTitle: 'Добавить новый PC',
    branchLabel: 'Филиал',
    pcNumber: 'Номер PC',
    add: 'Добавить',

    // PACKAGES
    packagesPageTitle: 'Пакеты',
    packagesSubtitle: 'Настройки цен и времени',
    addPackageBtn: '+ Добавить пакет',
    bookingDepositByRoom: 'Залог за бронь — по комнатам',
    bookingDepositByRoomDesc: 'Задайте залог отдельно для каждой комнаты. 0 = залога нет. Не возвращается при неявке.',
    noRooms: 'В этом филиале нет комнат. Создайте комнату в редакторе зала.',
    noRoomsFound: 'Комнаты не найдены (сначала создайте комнату)',
    noPackagesList: 'Пакетов нет. Нажмите "+ Добавить пакет".',
    roomNotSet: 'Комната не указана',
    perHour: 'сум/час',
    editPkg: 'Изменить',
    editPackageTitle: 'Редактировать пакет',
    newPackageTitle: 'Новый пакет',
    packageNameLabel: 'Название пакета',
    durationLabel: 'Длительность (минут)',
    priceLabel: 'Цена (сум)',
    roomSelectLabel: 'ВЫБЕРИТЕ КОМНАТУ',
    roomSelectRequired: 'Нужно выбрать хотя бы 1 комнату',
    minOneRoom: 'Нужно выбрать хотя бы одну комнату',
    update: 'Обновить',
    savedCheck: '✓ Сохранено',

    // PACKAGES — smart fields
    pkgTypeLabel: 'Тип пакета',
    pkgTypeSmall: 'Маленький (ежедневный)',
    pkgTypeBig: 'Большой (промо)',
    pkgFirstPurchaseOnly: 'Только для новых клиентов',
    pkgMaxAvgHours: 'Только для клиентов с менее X часов/мес (0 = без ограничений)',
    pkgIsRecommended: 'Рекомендуемый пакет (1 на клуб)',
    pkgDiscountLabel: 'Скидка',
    pkgDiscountWarn: 'Этот пакет дешевле стандартного тарифа на {pct}%',
    pkgSimTitle: 'Симуляция выручки (прошлый месяц)',
    pkgSimLoading: 'Вычисляется...',
    pkgSimResult: 'Если бы {count} клиент(ов) купили этот пакет, выручка изменилась бы на {sign}{amt} сум',
    pkgSimNote: '* Приблизительный расчёт',
    pkgSimNoRate: 'Почасовой тариф не задан — симуляция недоступна',

    // EXPENSES
    expensesTitle: '💸 Расходы',
    expensesSubtitle: 'Аренда, зарплата, электричество и прочие расходы',
    addExpenseBtn: 'Добавить расход',
    totalExpenses: 'Всего расходов',
    noExpenses: 'Расходов нет',
    noExpensesHint: 'Добавьте первый расход',
    categoryLabel: 'Категория',
    amountLabel: 'Сумма (сум)',
    dateLabel: 'Дата',
    recurMonthly: 'Повторяется ежемесячно',
    confirmDelete: 'Подтвердите удаление?',
    cat_ijara: 'Аренда',
    cat_oylik: 'Зарплата',
    cat_elektr: 'Электричество',
    cat_internet: 'Интернет',
    cat_jihoz: 'Оборудование',
    cat_snack: 'Поставка снеков',
    cat_marketing: 'Маркетинг',
    cat_tamir: 'Ремонт',
    cat_soliq: 'Налоги',
    cat_boshqa: 'Прочее',
    editExpenseTitle: 'Редактировать',
    newExpenseTitle: 'Новый расход',
    alertAmountRequired: 'Категория и сумма обязательны',
    tableActions: 'Действия',
    tableRecurring: 'Повтор',
    tableDate: 'Дата',
    tableCategory: 'Категория',
    tableDesc: 'Описание',
    tableAmount: 'Сумма',
    recurEveryMonth: 'Каждый месяц',

    // ANNOUNCEMENTS
    announcementsTitle: '📢 Объявления',
    addAnnouncement: 'Добавить объявление',
    validUntil: 'Действует до',
    discountPct: 'Скидка %',
    annSubtitle: 'Отправка новостей или скидок клиентам клуба через push-уведомления.',
    annBranchLabel: 'Филиал:',
    subInactive: 'Подписка неактивна',
    subInactiveDesc: 'Создание объявлений и push-уведомления работают только при активной подписке. Ранее созданные объявления видны, но новые создать нельзя.',
    viewSubscription: 'Посмотреть подписку →',
    subActive: 'Подписка активна',
    trialPeriod: 'пробный период',
    daysLeftAnn: 'Осталось',
    dayUnit: 'дн',
    newAnnouncement: 'Новое объявление',
    type_news: 'Новость',
    type_discount: 'Скидка',
    type_event: 'Событие',
    type_tournament: 'Турнир',
    annTitlePlh: 'Заголовок (например: Скидка 30% вечером!)',
    annBodyPlh: 'Текст — сообщение клиентам (например: Сегодня с 18:00 до 22:00...)',
    imageUrlOptional: 'URL изображения (необязательно)',
    ctaUrlOptional: 'URL ссылки (необязательно — кнопка)',
    expiryOptional: 'Дата окончания (необязательно)',
    pinToTop: 'Закрепить вверху',
    sendPushLabel: 'Отправить мобильный push',
    sending: 'Отправка...',
    sendAnnouncement: '📢 Опубликовать объявление',
    annListHeader: 'Созданные объявления',
    noAnnouncements: 'Объявлений пока нет. Создайте первое через форму выше.',
    annPinned: 'Закреплено',
    annArchived: 'В архиве',
    annPushSent: 'Push отправлен',
    annCreatedAt: 'Создано',
    unpin: 'Открепить',
    pinBtn: 'Закрепить',
    activateBtn: 'Активировать',
    archiveBtn: 'В архив',
    deleteBtn: 'Удалить',
    confirmDeleteAnn: 'Удалить это объявление?',
    errTitleBody: 'Заголовок и текст обязательны',
    errSubRequired: '❗ Только при активной подписке. Перейдите на страницу подписки.',
    errSubOnly: '❗ Только по подписке',

    // MEMBERSHIPS
    membershipsTitle: '💎 Абонемент',
    addMembership: 'Добавить абонемент',
    discountTitle: 'Скидка',
    sessionsLimit: 'Лимит сессий',
    membershipsPageTitle: '💎 Абонементы & Happy Hour',
    membershipsSubtitle: 'Планы подписки и специальные часы',
    tabAbonement: '💎 Абонементы',
    tabHappyHour: '⏰ Happy Hour',
    activeAbonements: 'Активные абонементы',
    monthlyAbonRevenue: 'Доход от абонементов в этом месяце',
    plansHeader: 'Планы',
    addPlan: '➕ Добавить план',
    nameLabel: 'Название',
    priceSumLabel: 'Цена (сум)',
    durationDaysLabel: 'Срок (дней)',
    sessionLimitLabel: 'Лимит сессий (0=без лимита)',
    dayUnit2: 'дн',
    discountSuffix: 'скидка',
    sessionUnit: 'сессий',
    unlimitedSessions: 'Неограниченно',
    deleteBtn2: 'Удалить',
    activeAbonementsHeader: 'Активные абонементы',
    noActiveAbonements: 'Активных абонементов нет',
    colUser: 'Пользователь',
    colPlan: 'План',
    colStartDate: 'Начало',
    colEndDate: 'Конец',
    colSessions: 'Сессии',
    alertNamePrice: 'Название и цена обязательны',
    alertNameRequired: 'Название обязательно',
    hhActiveNow: 'Happy Hour сейчас активен!',
    addHH: '➕ Добавить',
    newHHTitle: '➕ Новый Happy Hour',
    dayLabel: 'День',
    hourFromLabel: 'Час начала (0-23)',
    hourToLabel: 'Час окончания (0-23)',
    noHappyHours: 'Happy Hour не добавлен',
    colName: 'Название',
    colDay: 'День',
    colNow: 'Сейчас',
    colEnabled: 'Вкл',
    activeNow: 'Активен',
    day_all: 'Все дни',
    day_0: 'Воскресенье',
    day_1: 'Понедельник',
    day_2: 'Вторник',
    day_3: 'Среда',
    day_4: 'Четверг',
    day_5: 'Пятница',
    day_6: 'Суббота',

    // TOURNAMENTS
    tournamentsTitle: '🏆 Турниры',
    prizePool: 'Призовой фонд',
    participants: 'Участники',
    maxParticipants: 'Макс участников',

    // MAINTENANCE
    maintenanceTitle: '🔧 Техобслуживание',
    issue: 'Проблема',
    reportIssue: 'Сообщить о проблеме',
    resolve: 'Решено',

    // ROLE LABELS
    roleOwner: 'Владелец',
    roleStaff: 'Сотрудник',
    branch: 'Филиал',
    allLabs: 'Все',
    selectLabForShift: 'Выберите филиал для управления сменой',

    // PERIOD PICKER
    today: 'Сегодня',
    thisMonth: 'Этот месяц',

    // KASSA — additional
    todayRevenue: 'Доход сегодня',
    walkinSessions: 'Walk-in сессии',
    avgSession: 'Средняя сессия',
    auditLog: 'Журнал аудита',
    noRecords: 'Записей нет',
    openTag: 'открыта',
    shortage: 'Недостача',
    surplus: 'Излишек',
    closingCashLabel: 'Фактические наличные в кассе (сум)',
    openingCashLabel: 'Начальные наличные (в кассе)',
    noteLabel: 'Примечание',
    optionalPlaceholder: 'По желанию...',
    whoOpening: 'Кто открывает *',
    selectPlaceholder: '— Выберите —',
    payMethodPC: 'Доход сессий (PC + Бильярд + PS)',
    colTime: 'Время',
    colAction: 'Действие',
    colWho: 'Кто',
    colAmount: 'Сумма',
    colDetails: 'Подробнее',
    printReport: 'Распечатать',
    sessionsLabel: 'Сессии',
    newClientsLabel: 'Новые клиенты',
    cashInRegisterModal: 'Нал в кассе',

    // BAR PRE-ORDERS
    barPreorders: '🍔 Предзаказы из бара',
    allClubs: 'Все клубы',
    club: 'Клуб',
    noBarOrders: 'Нет предзаказов из бара',
    activeOrders: 'Активные',
    historyOrders: 'История',
    booking: 'Бронь',
    arrivalTime: 'Время прихода',
    minsRemaining: 'мин осталось',
    btnUnderstood: 'ПОНЯЛ — Буду готовить',
    btnMarkCash: 'Перевести в наличные',
    btnCancelOrder: 'Отменить',
    btnDelivered: 'ДОСТАВИЛ',
    orderCompleted: 'Завершено',
    confirmMarkCash: 'Перевести этот заказ в наличные? (Клиент оплатит при доставке)',
    confirmCancelOrder: 'Отменить и архивировать заказ? Деньги с баланса будут возвращены клиенту.',
    // TOURNAMENTS (full)
    tournamentsSubtitle: 'Организация и управление турнирами филиала',
    newTournament: '+ Новый турнир',
    newTournamentForm: 'Новый турнир',
    tournamentName: 'Название турнира *',
    tournamentGame: 'Игра (CS2, FC24...)',
    tournamentDescription: 'Описание...',
    tournamentEntryFee: 'Взнос за участие (сум)',
    tournamentPrizePool: 'Призовой фонд (сум)',
    tournamentMaxPlayers: 'Макс участников',
    tournamentCreate: 'Создать',
    statusUpcoming: 'Ожидается',
    statusActive: 'Идёт',
    statusFinished: 'Завершён',
    statusCancelled: 'Отменён',
    tournamentBack: '← Назад',
    tournamentStart: '▶️ Начать',
    tournamentFinish: '🏆 Завершить',
    tournamentCancel: '✗ Отменить',
    participantName: 'Имя участника...',
    addParticipant: '+ Добавить',
    participantPaid: '✓ Оплачено',
    participantUnpaid: 'Не оплачено',
    participantsLabel: 'Участники',
    noParticipants: 'Пока никого нет',
    entryFeeLabel: 'Взнос за участие',
    collectedFees: 'Собрано взносов',
    entryFeeEntry: 'сум вход',
    noTournaments: 'Турниров нет',
    noTournamentsDesc: 'Создайте первый турнир и привлекайте клиентов',
    guestLabel: 'Гость',

    // GAMES (full)
    gamesTitle: '🎮 Управление играми',
    gamesSubtitle: 'Игры, постеры и mp4 трейлеры для Desktop агента',
    addGame: '+ Добавить игру',
    gameName: 'Название игры *',
    gameSort: 'Порядок',
    gameExePath: 'Путь к exe (напр.: C:\\Games\\CS2\\cs2.exe)',
    gameShortDesc: 'Краткое описание — 1-2 предложения (показывается в hero панели)',
    gameFullDesc: 'Полное описание — сюжет, правила, особенности (показывается на странице игры)',
    gameEditTitle: 'Редактировать',
    gameNewTitle: 'Новая игра',
    gameInactive: 'Неактивно',
    deleteGameConfirm: 'Удалить игру?',
    fileTooLarge: 'Файл слишком большой. Макс:',
    uploadError: 'Ошибка загрузки',
    coverBtn: '🖼️ Обложка',
    coverBtnDone: '🖼️ Обложка ✓',
    heroBtn: '🎨 Тема',
    heroBtnDone: '🎨 Тема ✓',
    trailerBtn: '🎬 Трейлер',
    trailerBtnDone: '🎬 Трейлер ✓',
    editGameBtn: '✏️ Редактировать',
    genreOther: '🎮 Другое',
    noGames: 'Игры не добавлены',
    noGamesDesc: 'Добавьте игры для отображения в Desktop агенте',

    // MAINTENANCE (full)
    maintenanceSubtitle: 'История проблем и спецификации PC',
    mainTabIssues: '⚠️ Проблемы',
    mainTabSpecs: '🖥️ Спецификации PC',
    openIssues: 'Открытые проблемы',
    inProgressLabel: 'В работе',
    resolvedMonth: 'Решено в этом месяце',
    totalCost: 'Общие расходы',
    filterAll: 'Все',
    filterOpen: 'Открытые',
    filterInProgress: 'В работе',
    filterResolved: 'Решённые',
    addIssue: '➕ Добавить проблему',
    newIssueTitle: '🔧 Новая проблема',
    issueComputer: 'Компьютер',
    selectComputerPlaceholder: '— Выберите —',
    issueTechnician: 'Техник',
    technicianPlaceholder: 'Имя техника',
    issueCost: 'Стоимость (сум)',
    issueNotes: 'Примечание',
    issueDesc: 'Описание проблемы',
    issuePlaceholder: 'Опишите проблему...',
    missingIssueDesc: 'Необходимо описание проблемы',
    colPC: 'PC',
    colIssue: 'Проблема',
    colStatus: 'Статус',
    colTechnician: 'Техник',
    colCostHdr: 'Стоимость',
    colDate: 'Дата',
    colActions: 'Действия',
    noIssues: 'Проблем нет',
    statusOpen: 'Открыта',
    statusInProgress: 'В работе',
    statusResolved: 'Решена',
    specsType: 'Тип',
    specsGPU: 'GPU',
    specsRAM: 'RAM',
    specsStorage: 'Хранилище',
    specsCondition: 'Состояние',
    specsBroken: '🔴 Сломан',
    specsGood: '✅ Хорошо',
    specsBrokenShort: 'Сломан',
    specsGoodShort: 'Хорошо',

    // OBUNA (full)
    obunaTitleFull: '📋 Статус подписки',
    obunaSubtitle: 'Defuse SaaS — управление ежемесячной подпиской',
    currentStatus: 'Текущий статус',
    computersLabel: 'Компьютеры',
    daysLeft: 'Дней осталось',
    limitLabel: 'Лимит',
    statusTrial: 'Пробный период',
    statusExpired: 'Истёкший',
    statusCancelledSub: 'Отменена',
    statusActiveSub: 'Активна',
    trialUntil: 'Пробный:',
    trialUntilSuffix: 'до',
    expiresLabel: 'Истекает:',
    testModeNote: 'Тестовый режим — попробуйте подписку без реальной оплаты. Интеграция Click/Payme скоро.',
    subscriptionPlans: 'Тарифные планы',
    unlimitedComputers: 'Безлимит',
    computersUpToSuffix: 'компьютеров',
    activePlanBadge: '✅ Текущий план',
    recommendedBadge: '⭐ Рекомендуется',
    activePlanLabel: 'Активный план',
    testActivate: '🧪 Тест активация',
    activatingLabel: '⏳ Активируется...',
    activatedSuccess: '✅ Подписка активирована! (Тест режим)',
    realPaymentTitle: 'Реальная оплата — Click / Payme',
    realPaymentDesc: 'После подключения Merchant аккаунта будет добавлена интеграция. Пока работает тест режим.',
    comingSoon: 'Скоро',
    planSuffix: 'план',
    perMonth: 'сум/мес',

    // STAFF (full)
    roleKassir: 'Кассир',
    roleManager: 'Менеджер',
    roleTechnic: 'Техник',
    staffPageTitle: 'Сотрудники & Зарплата',
    staffPageSubtitle: 'Управление сотрудниками и расчёт зарплаты',
    tabStaff: '👤 Сотрудники',
    tabSalary: '💰 Зарплаты',
    tabAttendance: '⏱ Посещаемость',
    addStaff: '➕ Добавить сотрудника',
    editStaffTitle: '✏️ Редактировать сотрудника',
    newStaffTitle: '➕ Новый сотрудник',
    staffNameLabel: 'Имя *',
    staffPhoneLabel: 'Телефон',
    positionLabel: 'Должность',
    salaryTypeLabel: 'Тип зарплаты',
    salaryMonthly: '📅 Фиксированная месячная',
    salaryWeekly: '📆 Еженедельная',
    salaryShift: '⏱ Посменная',
    salaryHourly: '🕐 Почасовая',
    rateHourlyLabel: 'Ставка в час (сум)',
    rateShiftLabel: 'Ставка за смену (сум)',
    rateWeeklyLabel: 'Ставка в неделю (сум)',
    rateMonthlyLabel: 'Месячная ставка (сум)',
    staffNamePlh: 'Имя сотрудника',
    noStaff: 'Нет сотрудников',
    colStaffName: 'Имя',
    colPhone: 'Телефон',
    colPosition: 'Должность',
    colRate: 'Ставка',
    colActive: 'Активен',
    ratePerHour: '/час',
    ratePerShift: '/смену',
    ratePerWeek: '/нед',
    ratePerMonth: '/мес',
    staffNameRequired: 'Введите имя',
    confirmDeleteStaff: 'Подтвердить удаление?',
    salaryStaffRequired: 'Выберите сотрудника и введите сумму',
    salarySaved: 'Сохранено ✓ Также добавлено в расходы',
    monthlyTotalSummary: 'Всего зарплата за месяц',
    staffCountSuffix: 'сотрудников',
    salaryPaid: 'Выплачено',
    salaryPending: 'Ожидается',
    selectStaffLabel: 'Сотрудник',
    selectStaffPlh: '— Выберите сотрудника —',
    monthLabel: 'Месяц',
    calcSalaryTitle: '📝 Расчёт зарплаты',
    autoCalcTitle: '🧮 Автоматический расчёт',
    dateFromLabel: 'С',
    dateToLabel: 'По',
    calcBtn: '🧮 Рассчитать',
    fillMonthlyBtn: '🧮 Заполнить месячную',
    shiftsCountLabel: 'Смены',
    shiftPriceLabel: 'Цена смены',
    hoursCountLabel: 'Часы',
    hourPriceLabel: 'Цена часа',
    weeksCountLabel: 'Недели',
    weekPriceLabel: 'Цена недели',
    calcSalaryResult: 'Рассчитанная зарплата',
    recentSessionsLabel: 'Последние сессии',
    colStarted: 'Начало',
    colEnded: 'Конец',
    hoursUnitsLabel: 'Количество часов',
    shiftsUnitsLabel: 'Количество смен',
    weeksUnitsLabel: 'Количество недель',
    baseAmountLabel: 'Базовая сумма (сум)',
    bonusLabel: 'Бонус',
    fineLabel: 'Штраф',
    advanceLabel: 'Аванс (вычитается)',
    notesLabel: 'Примечание',
    optionalPlh: 'Необязательно...',
    totalSalaryLabel: 'Итого:',
    salaryHistoryTitle: 'История зарплат',
    colMonth: 'Месяц',
    colBase: 'Базовая',
    colBonus: 'Бонус',
    colFine: 'Штраф',
    colAdvance: 'Аванс',
    colTotal: 'Итого',
    salaryMarkedPaid: '✅ Выплачено',
    salaryPendingStatus: '⏳ Ожидается',
    markPaidBtn: 'Выплачено',
    activeAtWork: '● На работе',
    restingLabel: '○ Отдыхает',
    workHistoryBtn: '📋 История',
    workHistoryLabel: 'история работы',
    noWorkHistory: 'Нет истории',
    colStartWork: 'Начало',
    colEndWork: 'Завершение',
    colDurationHdr: 'Длительность',
    finishedStatus: '✓ Завершено',

    // FEEDBACKS (full)
    feedbacksTitle: '📝 Жалобы и предложения',
    fbAllClubs: 'Все клубы',
    fbAllStatuses: 'Все статусы',
    fbAllCategories: 'Все темы',
    fbStatusNew: 'Новый',
    fbStatusInProgress: 'В рассмотрении',
    fbStatusResolved: 'Решено',
    fbStatTotal: 'Всего',
    fbStatComplaints: 'Жалобы',
    fbStatSuggestions: 'Предложения',
    fbStatPraises: 'Благодарности',
    fbStatBugs: 'Ошибки',
    fbStatAvgRating: 'Средний рейтинг',
    fbClubLabel: 'Клуб:',
    fbAnonymous: '👤 Анонимно',
    fbPublic: '🙋 Открыто',
    fbOwnerResponse: 'Ваш ответ:',
    fbReply: 'Ответить',
    fbMarkResolved: 'Отметить решённым',
    fbResponsePlh: 'Ответ пользователю (если не анонимный — увидит в мобильном приложении)',
    fbSend: 'Отправить',
    fbCancelReply: 'Отмена',
    fbNoMessages: 'Нет сообщений',
    catComplaint: '😠 Жалоба',
    catSuggestion: '💡 Предложение',
    catPraise: '❤️ Благодарность',
    catBug: '🐛 Ошибка',
    catStaff: '👨 Сотрудник',
    catEquipment: '🖥️ Оборудование',
    catOther: '📝 Другое',

    // LEADERBOARD (full)
    leaderboardSubtitle: 'Рейтинг самых активных игроков',
    lbTotalPlayers: 'Всего игроков',
    lbAvgXP: 'Среднее XP',
    lbTopXP: 'Топ XP',
    lbTotalHours: 'Всего часов',
    lbTop3Title: 'Топ 3 игрока',
    lbFullRating: 'Полный рейтинг',
    lbColPlayer: 'Игрок',
    lbColXPLevel: 'XP / Уровень',
    lbColSessions: 'Сессии',
    lbColHours: 'Часы',
    lbColProgress: 'Прогресс',
    xpNeeded: 'XP нужно',
    lvlNew: 'Новый',
    lvlActive: 'Активный',
    lvlPro: 'Про',
    lvlLegend: 'Легенда',

    // TOPUP BONUSES (full)
    topupTitle: '🎁 Бонус за пополнение',
    topupCurrentBranch: 'Текущий филиал:',
    topupDesc: 'При пополнении баланса клиентом по правилу автоматически добавляется бонус.',
    topupMinAmountLabel: 'Сумма пополнения (сум)',
    topupBonusAmountLabel: 'Бонусная сумма (сум)',
    topupAddRule: '+ Добавить правило',
    topupNoRules: 'Пока нет бонусных правил',
    topupNoRulesHint: 'Добавьте через форму выше',
    topupRuleHash: 'Правило #',
    topupActive: '✓ Активно',
    topupInactive: '○ Отключено',
    topupWhenDeposited: 'при пополнении',
    topupEditBtn: '✏️ Изменить',

    // PROMO (full)
    promoTitle: '🎟️ Промокоды & Лояльность',
    promoSubtitle: 'Скидки, бонусные баллы и программа лояльности',
    tabPromoCode: '🎟️ Промокоды',
    tabLoyalty: '⭐ Уровни лояльности',
    promoNewCode: '+ Новый код',
    promoDiscountPercent: 'Процент (%)',
    promoDiscountFixed: 'Фиксированная (сум)',
    promoDiscountPctPlh: 'Процент (1-100)',
    promoDiscountSumPlh: 'Скидка (сум)',
    promoMinAmountPlh: 'Мин. сумма (сум)',
    promoMaxUsesPlh: 'Макс. использований (0=бессрочно)',
    promoCreateBtn: 'Создать',
    colCode: 'Код',
    colDiscount: 'Скидка',
    colMinAmount: 'Мин. сумма',
    colUsage: 'Использований',
    colExpiry: 'Срок',
    colState: 'Статус',
    promoNoCodes: 'Промокодов нет',
    promoStatusActive: 'Активен',
    promoStatusInactive: 'Неактивен',
    promoToggleOff: 'Отключить',
    promoToggleOn: 'Включить',
    loyaltyPointsTitle: '⭐ Начисление баллов',
    loyaltySessionPay: '💰 Оплата сессии',
    loyaltyBooking: '📅 Бронирование',
    loyaltyBirthday: '🎂 День рождения',
    loyaltyReferral: '👥 Приглашение друга',
    loyaltySessionPayDesc: 'Каждые 1000 сум → 10 баллов',
    loyaltyBookingDesc: 'Каждое бронирование → 50 баллов',
    loyaltyBirthdayDesc: 'Неделя ДР → ×2 балла',
    loyaltyReferralDesc: 'Новый пользователь → 200 баллов',
    loyaltyNote: 'Баллы начисляются автоматически. В мобильном приложении клиенты видят баллы и обменивают их на баланс (100 баллов = 1000 сум).',
    allRoomsOption: 'Для всех комнат',

    // LOGIN
    loginLoggingIn: 'Вход...',
    loginBtn: 'Войти →',
    loginOwner: '👑 Владелец',
    loginStaff2: '👤 Сотрудник',
    loginPassword: 'Пароль',
    loginPhone: 'Номер телефона',
    loginPin: 'PIN код',
    loginError: 'Произошла ошибка',

    // ACCESS CONTROL
    accessTitle: '🔐 Права доступа',
    rolesLabel: 'Роли',
    addNewRole: 'Добавить роль',
    rolePagesTitle: 'просмотр страниц',
    pagesSelected: 'страниц выбрано',
    selectAllPages: 'Выбрать все',
    clearAllPages: 'Очистить',
    savedMark: 'Сохранено ✓',
    savingLabel: 'Сохраняется...',
    selectRoleHint: 'Выберите роль слева',
    staffPinTitle: 'Сотрудники — PIN для входа',
    pinSetSuccess: 'PIN установлен для',
    setPinFor: 'Установить PIN для',
    pinMinDigits: 'Минимум 4 цифры',
    setPinBtn: 'Установить',
    rolePlh: 'менеджер, кассир...',

    // THEME
    themeTitle: '🎨 Дизайн & Тема',
    themeSubtitle: 'Настройте внешний вид Shell — изменения применятся на всех компьютерах',
    presetColors: 'Готовые цвета',
    customColor: 'Пользовательский цвет',
    mainColorLabel: 'Основной цвет',
    bgColorLabel: 'Цвет фона',
    bgLabel: 'Фон:',
    designStyle: 'Стиль дизайна',
    classicLabel: 'Классический',
    classicDesc: 'Стандартный вид',
    glassDesc: 'Frosted эффект',
    themeSaved: '✓ Сохранено!',
    livePreview: 'Живой предпросмотр',

    // APPS
    appsTitle: '🚀 Каталог программ',
    appsSubtitle: 'Программы в Shell — запускаются автоматически при нажатии клиентом',
    appsPresetsBtn: '📋 Готовые программы',
    appsAddBtn: '+ Добавить программу',
    appsAllFilter: '🚀 Все',
    appsNone: 'Программы не добавлены',
    appsNoneHint: 'Нажмите "Готовые программы", чтобы добавить Steam, Discord и другие',
    appColName: 'Название',
    appColCategory: 'Категория',
    appColExePath: 'Путь к exe',
    appColOrder: 'Порядок',
    appColStatus: 'Статус',
    appActive: 'Активна',
    appHidden: 'Скрыта',
    appSaveRequired: 'Название и путь к exe обязательны',
    appAddTitle: '+ Новая программа',
    appEditTitle: '✏️ Редактировать программу',
    appNameLabel: 'Название программы *',
    appCategoryLabel: 'Категория *',
    appIconLabel: 'URL иконки (необязательно)',
    appExeLabel: 'Путь к exe (Windows) *',
    appArgsLabel: 'Аргументы (необязательно)',
    appSortLabel: 'Порядок',
    appActiveOption: 'Активна (видима)',
    closeBtn: 'Закрыть',
    appAddBtn2: 'Добавить',
    presetsModalTitle: '📋 Готовые программы',
    presetsModalHint: 'Нажмите — заполнится автоматически, затем измените путь под свою систему',
    appCatLauncher: '🎮 Игровая платформа',
    appCatCompetitive: '🏆 Киберспорт',
    appCatCommunication: '💬 Связь',
    appCatSystem: '⚙️ Система / Графика',
    appCatPeripheral: '🖱️ Периферия',
    appCatStreaming: '📡 Стриминг',
    appCatBrowser: '🌐 Браузер',

    // BULK BOOKINGS
    thisWeek: 'Эта неделя',
    bulkTitle: '📅 Брони',
    bulkRefresh: '🔄 Обновить',
    bulkDateRangeLabel: 'период',
    bulkAllTime: '📊 Всё время',
    bulkStatTotal: 'Всего броней',
    bulkStatEarned: 'Доход',
    bulkStatTodayGroups: 'Броней сегодня',
    bulkStatTodayEarned: 'Доход сегодня',
    bulkAllClubs: 'Все клубы',
    bulkAllStatuses: 'Все статусы',
    bulkClearDate: '✕ Сбросить даты',
    bulkNone: 'Брони не найдены',
    bulkShowing: 'Показано',
    bulkSeatsLabel: 'МЕСТА',
    bulkStatusPending: 'Ожидает',
    bulkStatusPartialAct: 'Частично активно',
    bulkStatusActive: 'Активно',
    bulkStatusCompleted: 'Завершено',
    bulkStatusExpired: 'Просрочено',
    bulkStatusPartialExp: 'Частично просрочено',
    bulkStatusCancelled: 'Отменено',
    bulkModeShared: '👥 Общий пул',
    bulkModePhone: '📞 По номеру',
    bulkUnknown: 'Неизвестно',
    bulkSeatsActiveLabel: 'актив',

    // LAUNCHER THEMES
    launcherTitle: '🎨 Дизайны лаунчера',
    launcherCurrentBranch: 'Текущий филиал:',
    launcherCurrentDesign: 'Текущий дизайн:',
    launcherComingSoon: 'Скоро',
    launcherPreviewBtn: '👁 Просмотр',
    launcherSelectedBtn: '✓ Выбран',
    launcherNotReadyBtn: 'Не готов',
    launcherUploadHtml: '⬆ Загрузить HTML',
    launcherCloseBtnLabel: '✕ Закрыть',
    launcherNoBranchAlert: 'Сначала выберите филиал в Super Admin → Выбор филиала',
    launcherNotReadyMsg: 'ещё не готов. Скоро будет добавлен.',
    launcherPickedMsg: 'выбран. Все desktop-агенты обновятся автоматически в течение 60 секунд.',
    launcherHtmlOnly: 'Только .html файлы',
    launcherFileTooLarge: 'Файл больше 5MB',
    launcherUpdatedMsg: 'обновлён. Все desktop-агенты загрузят новую версию в течение 5 минут.',
    launcherSizeLabel: 'Размер',
    launcherUploadError: 'Ошибка при загрузке',
    themeHudDesc: 'Esports HUD — notch, magenta+cyan+lime, наклонный заголовок. Полная интеграция с backend.',
    themeDesign1Desc: 'Чистый современный, акцент на карте PC. Синяя-teal палитра. ЭТАЛОН — наиболее полный.',
    themeDesign2Desc: 'Геймификация — leaderboard, монеты, квесты, XP. Фиолетовый+розовый.',
    themeDesign3Desc: 'Консольный домашний экран, нижний dock. Синяя палитра.',
    themeDesign4Desc: 'Левое вертикальное меню, emerald цвет. Широкая контентная область.',
    themeDesign5Desc: 'Fullscreen афиша + filmstrip навигация. Янтарный цвет.',
    themeDesign6Desc: 'Турнирный подиум в центре. Crimson палитра. Для esports клубов.',
    themeDesign7Desc: 'Компактный список строками. Teal цвет. Для клубов с малым количеством мест.',
    themeDesign8Desc: 'Центральный таймер + радиальные кнопки. Indigo. Для 1920×1080.',
    themeDesign9Desc: 'Рекламный billboard, рекламный rail. Orange — монетизация. Для 1920×1080.',
    themeDesign10Desc: 'Монохромный премиум. Белый + один lime акцент. Очень чисто.',
    launcherActiveBadge: '● АКТИВЕН',
    launcherSelectBtn: '✓ Выбрать',
    launcherLicense: "Одноразовая лицензия",
    launcherPaySum: "Сумма оплаты",
    launcherPayMethod: "Выберите способ оплаты",
    launcherPreparing: "⏳ Подготовка...",
    launcherPayVia: "оплатить через",
    launcherPayOk: "Оплата принята!",
    launcherActivatingMsg: "активируется...",
    launcherScanQr: "отсканируйте приложением",
    launcherAmountLabel: "Сумма:",
    launcherQrExpired: "⏰ 10 минут прошло — оплата не подтверждена.",
    launcherNewQr: "🔄 Получить новый QR",
    launcherChecking: "Проверяем оплату... (ESC — назад)",
    launcherOpenBrowser: "🌐 Открыть в браузере",
    launcherGoBack: "← Назад",
    launcherNoConfig: "Платёжная система не настроена.",
    launcherNoConfigContact: "Обратитесь по номеру:",
    launcherNavHint: "← → для переключения · ESC закрыть",
    launcherNotPurchased: "🔒 Не куплен",
    launcherNotPurchasedMsg: "Этот дизайн не куплен",
    launcherBuyBtn: "💳 Купить",
    launcherFree: "БЕСПЛАТНО",
    launcherSelectedBadge: "✓ ВЫБРАН",
    launcherBranchLabel: "Филиал:",
    launcherActiveLabel: "Активный:",
    launcherLoadingPurch: "загрузка...",
    launcherLoadError: "⚠ Ошибка загрузки — повторить",
    launcherPurchasedCount: "Куплено:",
    launcherBuyBadge: "🔒 Купить",
    launcherCloseBtn: "Закрыть",
    launcherPurchasedUnit: "шт.",

    // PAYMENT SETTINGS
    payTitle: '💳 Настройки оплаты',
    paySubtitle: 'Настройка платёжных провайдеров и просмотр webhook-эндпоинтов',
    payWarning: 'API-ключи хранятся в файле /cybernet/backend/.env. На этой странице только инструкции по конфигурации и тест. Добавьте ключи напрямую в .env и перезапустите сервер.',
    payStatTotal: 'Всего платежей',
    payStatSuccess: 'Успешных',
    payStatPending: 'В ожидании',
    payStatAmount: 'Общая сумма',
    payProviderLabel: 'ПРОВАЙДЕРЫ',
    payProviderHint: 'нажмите на карточку для деталей',
    payEnvExample: '.ENV ПРИМЕР (backend/.env)',
    payEnvSettings: '.ENV НАСТРОЙКИ',
    payNoEnvRequired: 'Отдельные ENV-ключи не требуются.',
    payWebhookLabel: 'WEBHOOK ЭНДПОИНТЫ',
    payInstructions: '📋 Инструкция:',
    payCopyBtn: 'Копировать',
    payConnOk: '✓ Соединение OK',
    payConnFail: '✗ Ошибка',
    payLimitsTitle: '⚙️ Общие Лимиты',
    payMinLabel: 'Минимальный платёж',
    payMaxLabel: 'Максимальный платёж',
    payConnFailed: 'Не удалось подключиться',
    payLimitsAlert: 'Лимиты нужно обновить вручную в .env:\n',
    payNotAvailable: 'Пока недоступно',
    payDocsInstr: 'перейдите на страницу, получите API-ключи и добавьте в /cybernet/backend/.env.',

    // LAB INFO SETTINGS
    labInfoTitle: '📸 Информация и фото клуба',
    labInfoSelectClub: 'Выбор клуба:',
    labInfoDataSection: 'Данные',
    labFieldName: 'Название',
    labFieldAddress: 'Адрес',
    labFieldDesc: 'Описание',
    labFieldPhone: 'Телефон',
    labFieldHours: 'Время работы',
    labFieldParentPhone: 'Родительский телефон',
    labFieldEmergency: 'Экстренный тел',
    labMapSection: 'Местоположение',
    labMapHint: 'Нажмите на карту или перетащите маркер',
    labSaved: '✅ Сохранено',
    labCoverChanged: '✅ Обложка изменена',
    labPhotosSection: 'Фотогалерея',
    labUploadPhotos: '📤 Загрузить фото (несколько)',
    labPhotoHint: 'JPG/PNG/WEBP · Макс. 5MB каждый',
    labCurrentCover: '🏆 Текущая ОБЛОЖКА:',
    labPaySection: '💳 Реквизиты Payme / Click',
    labPayDesc: 'Оплата картой поступает напрямую на ваш счёт Payme/Click. Мы только проверяем через webhook, прошла ли оплата — деньги к нам не поступают. Если не настроено, клиенты не смогут оплатить картой в вашем клубе.',
    labPayConfigured: '✓ Настроено',
    labPayNotConfigured: '✗ Не настроено',
    labSecretKeySet: '(установлен — введите новый для изменения)',
    labSecretKeepBlank: 'оставьте пустым, если не меняется',
    labNewSecretKey: 'Новый секретный ключ',
    labRemoveClick: 'Удалить Click',
    labRemovePayme: 'Удалить Payme',
    labSavePayBtn: '💾 Сохранить реквизиты Payme/Click',
    labWebhookNote: '📎 Webhook URL (для кабинета Payme/Click):',
    labPhotoCount: 'фото',
    labConfirmDeletePhoto: 'Удалить этот снимок?',
    labConfirmRemoveProvider: 'реквизиты: удалить? Оплата картой в этом клубе отключится.',
    labPaymentSaved: '✅ Реквизиты Payme/Click сохранены',
    labProviderRemoved: 'реквизиты удалены',

    // FISCAL
    sevenDays: '7 дней',
    thirtyDays: '30 дней',
    fiscalTitle: '🧾 Фискальный ККМ',
    fiscalSubtitle: 'Онлайн ККМ — требование Налогового комитета Узбекистана',
    fiscalMockBadge: 'Mock режим',
    tabReceipts: '🧾 Чеки',
    tabKkmSettings: '⚙️ Настройки ККМ',
    tabFiscalStats: '📊 Статистика',
    fiscalSent: 'Отправлен',
    fiscalPending: 'Ожидает',
    fiscalFailed: 'Ошибка',
    fiscalAllStatuses: 'Все статусы',
    fiscalNewReceipt: '+ Новый чек',
    fiscalStatTotal: 'Всего чеков',
    fiscalStatAmount: 'Общая сумма',
    fiscalResend: 'Отправить повторно',
    fiscalColNumber: 'Номер чека',
    fiscalColVat: 'НДС (12%)',
    fiscalColDate: 'Дата',
    fiscalNoneFound: 'Чеки не найдены',
    fiscalNewReceiptTitle: '🧾 Новый фискальный чек',
    fiscalAmountPlh: 'Сумма',
    fiscalItemNamePlh: 'Название товара/услуги',
    fiscalDefaultItem: 'Компьютерные услуги',
    fiscalCreateBtn: 'Создать',
    fiscalFormRequired: 'Клуб и сумма обязательны',
    fiscalMockWarning: 'Mock режим — нет подключения к API Налогового комитета. Чеки сохраняются как тестовые данные. Для реальной интеграции введите KKM ID.',
    fiscalModeLabel: 'Режим:',
    fiscalRealMode: 'Реальный ККМ',
    fiscalMockMode: 'Mock (тест)',
    fiscalFiscalActive: 'Фискал активен',
    fiscalKkmIdLabel: 'KKM ID (необязательно)',
    fiscalStatVat: 'Итого НДС',
    fiscalDailyChart: 'Чеки по дням',

    // LAYOUT EDITOR
    layoutTitle: '🗺️ Редактор зала',
    layoutSubtitle: 'Перетащите комнаты и ПК на схему',
    layoutPlaced: 'размещено',
    layoutAddRoom: '+ Добавить комнату',
    layoutRoomNamePlh: 'Название комнаты...',
    layoutSavedState: '✓ Сохранено',
    layoutAlertAddRoom: 'Сначала добавьте комнату',
    layoutAlertNoSpace: 'В комнате нет места',
    layoutAlertSaveError: 'Ошибка сохранения',
    layoutConfirmDeleteRoom: 'Удалить комнату?',
    layoutUnplaced: 'НЕ РАЗМЕЩЕНЫ',
    layoutAllPlaced: '✓ Все размещены',
    layoutClickTip: '💡 Нажмите → в первую комнату',
    layoutStatusLabel: 'СТАТУС',
    layoutRoomsLabel: 'КОМНАТЫ',
    layoutEmptyHint: 'Нажмите "+ Добавить комнату"',
    layoutStatusAvailable: 'Свободен',
    layoutStatusBusy: 'Занят',
    layoutStatusBroken: 'Сломан',
    layoutStatusOffline: 'Офлайн',
    layoutTip1: '⠿ Тяните шапку комнаты → перемещается вся комната с ПК',
    layoutTip2: 'Тяните ПК → переместить (комната определяется автоматически)',
    layoutTip3: '↘ Угол → изменить размер',
    layoutTip4: '🖱 Scroll → карта · Ctrl+Scroll →',
    layoutTip5: '✕ → убрать',
    layoutRenameBtn: 'Переименовать',
    layoutColorBtn: 'Изменить цвет',
    layoutDeleteRoomBtn: 'Удалить комнату',
    // CRM
    crmTitle: '👤 CRM — Клиенты',
    crmSubtitle: 'База клиентов, сегменты и маркетинговые кампании',
    crmTabClients: '👥 Клиенты',
    crmTabSegments: '🎯 Сегменты',
    crmTabCampaign: '📢 Кампания',
    crmSearchPlh: 'Имя или телефон...',
    crmAllSegments: 'Все сегменты',
    crmSegAll: 'Все пользователи',
    crmSeg7d: 'Активные (7 дней)',
    crmSeg14d: 'Неактивные (14 дней)',
    crmSeg30d: 'Неактивные (30 дней)',
    crmSeg14dMissed: 'Не приходили 14 дней',
    crmSeg30dMissed: 'Не приходили 30 дней',
    crmSegHighBalance: 'Высокий баланс',
    crmSegBirthdayToday: '🎉 День рождения сегодня',
    crmSegBirthdayMonth: 'День рождения в этом месяце',
    crmColName: 'Имя',
    crmColPhone: 'Телефон',
    crmColBalance: 'Баланс',
    crmColSessions: 'Сессии',
    crmColLastVisit: 'Последний визит',
    crmColSource: 'Источник',
    crmDaysAgo: '{d} дней назад',
    crmStatBalance: 'Баланс',
    crmStatPoints: 'Баллы',
    crmStatSessions: 'Сессии',
    crmStatSpent: 'Потрачено',
    crmBirthday: 'День рождения',
    crmSource: 'Источник',
    crmLastSessions: 'Последние сессии',
    crmNotes: 'Заметки',
    crmAddNote: 'Добавить заметку...',
    crmSaved: 'Сохранено',
    crmSegHint: 'Нажмите на сегмент — фильтр применится автоматически на вкладке Клиенты',
    crmNewCampaign: '📢 Новая кампания',
    crmSegCountFound: '→ Найдено {n} пользователей',
    crmBonusLabel: '🎁 Сумма бонуса — начисляется на балансы автоматически',
    crmBonusPlh: '0 — без бонуса',
    crmBonusTotalCalc: 'Итого: {total} ({n} × {amt})',
    crmTitleLabel: 'Заголовок',
    crmBodyLabel: 'Текст',
    crmPreviewLabel: '📱 Предпросмотр сообщения (пример)',
    crmNoUsers: 'В этом сегменте нет пользователей',
    crmSending: '⏳ Отправляется...',
    crmSendTo: '📤 Отправить {n} игрокам',
    crmSentResult: '✅ Отправлено {n} игрокам',
    crmSentBonus: '· Итого начислено {total}',
    crmCampaignHistory: 'История кампаний',
    crmNoCampaigns: 'Кампаний ещё нет',
    crmHistoryAll: 'Все',
    crmPerPerson: 'чел',
    crmConfirmTitle: '✅ Подтверждение',
    crmConfirmMsg: '{n} игрокам будет отправлено сообщение',
    crmConfirmBonusMsg: 'и каждому {bonus} на баланс',
    crmConfirmTotalMsg: 'Итого: {total}. Продолжить?',
    crmConfirmSend: '📤 Да, отправить',
    crmTplBirthdayTodayTitle: '🎂 С днём рождения, {name}!',
    crmTplBirthdayTodayBody: 'Поздравляем с днём рождения! {club} дарит вам {amount} сум. Используйте подарок в нашем гейм-клубе 🎁',
    crmTplInactive14dTitle: '👋 {name}, мы скучаем!',
    crmTplInactive14dBody: '14 дней не видели вас. {club} приготовил {amount} сум бонуса. Заходите сегодня 🎮',
    crmTplInactive30dTitle: '🎮 {name}, подарок за месяц!',
    crmTplInactive30dBody: 'Не были у нас месяц! Ждём вас в {club} — специально для вас {amount} сум в подарок 🎮',
    crmTplBirthdayMonthTitle: '🎂 С днём рождения!',
    crmTplBirthdayMonthBody: 'Подарок от {club}: {amount} сум зачислено на ваш баланс. Приятной игры 🎁',
    crmTplHighBalanceTitle: '💰 Специальное предложение, {name}!',
    crmTplHighBalanceBody: '{club} дарит лояльным клиентам {amount} сум бонуса. Спасибо!',
    crmTplDefaultTitle: '🎮 Сообщение от {club}',
    crmTplDefaultBody: 'Уважаемый {name}, специальное предложение от {club}: {amount} сум зачислено на ваш баланс!',
    crmSelectSegment: 'Выберите сегмент',
    crmSegUsersList: 'Список',
    crmMoreUsers: 'скрыто',
    // Clients
    clientsTotalUsers: 'Пользователей в базе: {n}',
    clientNewBtn: '+ Новый клиент',
    clientNotFound: 'Клиенты не найдены',
    clientColName: 'Клиент',
    clientColHours: 'Часы',
    clientColPackage: 'Активный пакет',
    clientDebt: 'Долг',
    clientSessionUnit: '',
    clientHourUnit: 'ч',
    clientPackageSuffix: 'пакет',
    clientActPackageBtn: '▶ Пакет',
    clientTopupBtn: '+ Баланс',
    clientPasswordBtn: 'Пароль',
    clientAmountPositive: 'Сумма должна быть больше 0',
    clientPassMinChars: 'Пароль минимум 4 символа',
    clientSelectPackage: 'Выберите пакет',
    clientCreateTitle: '👤 Создать нового клиента',
    clientFieldFullName: 'ИМЯ И ФАМИЛИЯ',
    clientFieldPhone: 'НОМЕР ТЕЛЕФОНА',
    clientFieldPassword: 'ПАРОЛЬ (для входа в приложение)',
    clientFieldInitBalance: 'НАЧАЛЬНЫЙ БАЛАНС (необязательно)',
    clientPassMinCharsPlh: 'Минимум 4 символа',
    clientCreateBtn: '✓ Создать',
    clientTopupTitle: '💰 Пополнение баланса',
    clientInfoName: 'Клиент:',
    clientInfoPhone: 'Телефон:',
    clientInfoBalance: 'Текущий баланс:',
    clientTopupAmountLabel: 'СУММА ПОПОЛНЕНИЯ',
    clientTopupAsDebt: 'Добавить как долг',
    clientTopupDebtNote: 'Клиент увидит красное предупреждение в конце сеанса',
    clientPayDebtTitle: '💸 Погасить долг',
    clientTotalDebt: 'Общий долг:',
    clientPayAmountLabel: 'СУММА ОПЛАТЫ',
    clientPayDebtFull: 'Полностью',
    clientPayAccepted: 'принято',
    clientPasswordTitle: '🔑 Смена пароля',
    clientNewPasswordLabel: 'НОВЫЙ ПАРОЛЬ',
    clientNewPasswordPlh: 'Введите новый пароль',
    clientDebtUnpaid: 'не оплачен',
    clientPayDebtBtn: '💸 Погасить',
    clientTotalSessions: 'Всего сессий:',
    clientTotalSpent: 'Всего потрачено:',
    clientRegistered: 'Зарегистрирован:',
    clientActivatePackage: '▶ Активировать пакет',
    clientPasswordBtnShort: '🔑 Пароль',
    clientLastSessions: 'ПОСЛЕДНИЕ СЕССИИ',
    clientNoSessions: 'Сессий нет',
    clientHourly: 'Почасово',
    clientCloseBtn: 'Закрыть',
    clientActivatePackageTitle: '▶ Активировать пакет',
    clientVoucherCreated: 'Ваучер создан!',
    clientVoucherInst1: 'Клиент подходит к любому свободному ПК',
    clientVoucherInst2: 'вводит логин и пароль',
    clientVoucherInst3: 'сессия запустится автоматически',
    clientInfoPackage: 'Пакет:',
    clientInfoDuration: 'Длительность:',
    clientInfoPaid: 'Оплачено:',
    clientInfoRemainingBalance: 'Остаток баланса:',
    clientInfoValidFor: 'Действует:',
    clientMinuteUnit: 'минут',
    clientMinShort: 'мин',
    clientHourShort: 'ч',
    clientHourFull: 'ч',
    clientRoomLabel: 'КОМНАТА',
    clientSelectRoom: 'Выберите комнату...',
    clientSelectPackageLabel: 'ВЫБЕРИТЕ ПАКЕТ',
    clientNoPackages: 'В этой комнате нет активных пакетов',
    clientInsufficientBalance: '⚠ Недостаточно баланса',
    clientActivateHint: '💡 После оплаты клиент подходит к любому свободному ПК и вводит логин/пароль — сессия запустится автоматически',
    clientActivateBtn: '💳 Оплатить и активировать',
    clientPackagesTitle: 'Пакеты',
    clientVoucherWaiting: 'Ожидает',
    clientVoucherRemaining: 'Осталось:',
    clientVoucherTotalRemaining: 'Всего осталось:',

    // SNACK POS
    snackTitle: '🍕 Snack-bar POS',
    snackSubtitle: 'Буфет / продажа напитков',
    snackShiftOpen: '● Смена открыта · ⏹ Закрыть',
    snackShiftClosed: '○ Смена закрыта · ▶ Открыть',
    snackCompOrderOn: '✓ Заказ с ПК включён',
    snackCompOrderOff: '○ Заказ с ПК отключён',
    snackCompOrderOnHint: 'Пользователи могут делать заказы (с ПК)',
    snackCompOrderOffHint: 'Заказ отключён — кнопка скрыта на ПК',
    snackTabPos: '🛒 Касса',
    snackTabOrders: 'Открытые',
    snackTabSmena: 'Смена',
    snackTabProducts: 'Товары',
    snackTabCats: 'Категории',
    snackCategoryLabel: 'Категория',
    snackPickCategory: 'Выберите категорию',
    snackCategoryRequired: '⚠ Категория обязательна — товары фильтруются по категории в лаунчере и мобильном приложении',
    snackNoCategory: 'Нет категории',
    snackAddEmojiLabel: 'Эмодзи (иконка товара)',
    snackCatHelp: 'Категории видны в лаунчере и мобильном приложении. Название на UZ обязательно, на RU рекомендуется — для русскоязычных пользователей.',
    snackCatAddTitle: 'Добавить категорию',
    snackCatNameUzPlh: 'Nomi (O\'zbek) *',
    snackCatNameRuPlh: 'Название (Русский)',
    snackCatNameRequired: 'Название категории обязательно',
    snackCatProductsSuffix: 'товаров',
    snackCatDeleteConfirm: 'Удалить категорию "{name}"? Товары не удалятся, но останутся без категории.',
    snackCatEmpty: 'Категорий нет. Добавьте через форму выше.',
    snackTabShortage: 'Недостача',
    snackTabStats: 'Статистика',
    snackBarcodePlh: 'Сканируйте или введите штрихкод...',
    snackNotFound: 'Не найдено',
    snackAllCats: 'Все',
    snackStockLeft: 'Остаток:',
    snackNoProducts: 'Товаров нет',
    snackCart: '🛒 Корзина',
    snackPickProduct: 'Выберите товар',
    snackPcPlh: 'Номер ПК (необязательно)',
    snackPayCash: '💵 Наличные',
    snackPayTerminal: '💳 Терминал',
    snackDebtOn: '🔴 Долг (отмечено)',
    snackDebtOff: '+ Отметить как долг',
    snackDebtUserPlh: 'Имя клиента или телефон...',
    snackSearching: 'Поиск...',
    snackDebtUserRequired: '* Выбор клиента обязателен',
    snackDebtLabel: '(долг)',
    snackSaveDebt: '🔴 Сохранить как долг',
    snackSell: '✅ Продать',
    snackClear: 'Очистить',
    snackSoldFlash: '✅ Продано!',
    snackNoOpenOrders: 'Открытых заказов нет',
    snackDebtBadge: '🔴 ДОЛГ',
    snackPaid: 'Оплачено ✓',
    snackOpenShiftTitle: '▶ Открыть новую смену',
    snackAdminLabel: 'Администратор *',
    snackSelectAdmin: '— Выберите администратора —',
    snackAdminPlh: 'Имя администратора...',
    snackNoStaff: '⚠ Сотрудники не добавлены.',
    snackGoStaffPage: 'Перейти на страницу сотрудников',
    snackOrManual: 'или введите имя вручную.',
    snackOpenCashLabel: 'Начальная сумма в кассе (сум)',
    snackOpenBtn: '▶ Открыть',
    snackCloseShiftTitle: '⏹ Закрыть смену',
    snackInfoAdmin: '👤 Администратор:',
    snackInfoOpened: '🕐 Открыта:',
    snackInfoOpenCash: '💵 Начальная:',
    snackInfoOrders: '📋 Заказы:',
    snackInfoRevenue: '💰 Доход за смену:',
    snackOrderCountFmt: '{n}',
    snackCloseCashLabel: 'Итоговая сумма в кассе (сум) *',
    snackDiff: 'Разница:',
    snackExpected: 'ожидалось:',
    snackCloseBtn: '⏹ Закрыть',
    pinLabel: 'PIN-код',
    pinRequired: 'Введите PIN-код',
    pinMin4: 'Минимум 4 цифры',
    pinPlh: '4+ цифр',
    pinLeaveBlank: 'оставьте пустым — не изменится',
    snackPinChangeTitle: 'Введите новый PIN',
    snackPinEnterTitle: 'Введите PIN-код',
    snackPinEmpty: 'PIN не может быть пустым',
    snackPinChanged: 'PIN изменён ✓',
    snackPinWrong: 'Неверный PIN',
    snackPinSave: 'Сохранить',
    snackPinLogin: 'Войти',
    snackChangePin: '🔑 Изменить PIN',
    snackLock: '🔒 Заблокировать',
    snackAddProduct: '+ Добавить товар',
    snackNamePlh: 'Название *',
    snackPricePlh: 'Цена (сум) *',
    snackCostPlh: 'Себестоимость (сум)',
    snackStockPlh: 'Остаток (шт)',
    snackBarcodePlhAdd: '🔍 Штрихкод (необязательно) — сканируйте или введите вручную',
    snackImgChange: 'Изменить',
    snackImgAdd: 'Добавить фото',
    snackImgDeleteConfirm: 'Удалить фото?',
    snackAutoFindPhoto: 'Авто',
    snackAutoFindPhotoHint: 'Найти фото автоматически из Open Food Facts',
    snackAutoFindPhotoConfirm: 'Текущее фото будет заменено. Продолжить?',
    snackAutoFindPhotoLoading: 'Ищу...',
    snackAutoFindPhotoError: 'Фото не найдено',
    snackProductActive: 'Активен',
    snackProductInactive: 'Неактивен',
    snackStockDona: 'Остаток: {n} шт',
    snackUploadError: 'Ошибка загрузки',
    snackShiftOpenStatus: '● СМЕНА ОТКРЫТА',
    snackShiftClosedStatus: '○ СМЕНА ЗАКРЫТА',
    snackSmenaRevenue: '💰 Доход:',
    snackSmenaReturns: '↩ Возврат:',
    snackNoShift: 'Смена не открыта. Нажмите кнопку, чтобы начать новую смену.',
    snackRefresh: '🔄 Обновить',
    snackCloseShiftBtn: '⏹ Закрыть смену',
    snackOpenShiftBtn: '▶ Открыть смену',
    snackShiftOrdersTitle: 'История заказов ({n})',
    snackNoOrdersYet: 'Заказов пока нет',
    snackShiftHistoryTitle: 'История смен',
    snackShiftHistoryEmpty: 'Пока нет закрытых смен',
    snackOrdersLabel: 'заказов',
    snackEditProduct: 'Редактировать',
    snackCostLabel: 'Себестоимость',
    snackAlertName: 'Название обязательно',
    snackAlertPrice: 'Неверная цена',
    snackReturnSelectTitle: 'С какого заказа возврат?',
    snackNoReturnableOrders: 'Оплаченные заказы не найдены',
    snackDebtOrderBadge: '🔴 ДОЛГ',
    snackReturnBtn: '↩ Возврат',
    snackReturnTitle: '↩ Возврат — заказ #{n}',
    snackSoldInfo: 'Продано: {qty} шт · {price} сум/шт',
    snackReturnQtyLabel: 'Возврат:',
    snackReturnTotal: 'Сумма возврата:',
    snackReturnReasonPlh: 'Причина (необязательно)',
    snackReturnConfirm: '↩ Подтвердить возврат',
    snackInvHistory: '📋 История',
    snackInvNew: '📝 Новый подсчёт',
    snackInvEmpty: 'Инвентаризация ещё не проводилась',
    snackShortageCount: '{n} товаров — {total} шт недостача',
    snackNoShortage: '✓ Недостачи нет',
    snackInvColProduct: 'Товар',
    snackInvColExpected: 'Ожидаемо',
    snackInvColActual: 'Фактически',
    snackInvColDiff: 'Разница',
    snackKamomad: 'НЕДОСТАЧА',
    snackInvHint: 'Введите фактическое количество. После сохранения остатки обновятся.',
    snackInvColSystem: 'В системе',
    snackInvColInput: 'Фактически (введите)',
    snackInvNotePlh: 'Примечание (необязательно, напр: вечерняя смена, Саша)',
    snackInvSave: '💾 Сохранить',
    snackStatsTodayOrders: 'Заказов за сегодня',
    snackStatsTodayRevenue: 'Доход за сегодня',
    snackStatsOpenOrders: 'Открытые заказы',
    snackTopProducts: 'Топ товары (сегодня)',
    snackDona: 'шт',
    snackAlertAdminName: 'Введите имя администратора',
    snackAlertReturnSelect: 'Выберите товар для возврата',
    snackAlertDebtUser: 'Выберите клиента для долга',

    // SUPER ADMIN
    superAdminSubtitle: 'Управление всеми филиалами',
    superTabSelect: '🎯 Выбрать филиал',
    superTabAnalytics: '📊 Аналитика',
    superTabOwners: '🏢 Филиалы',
    superTabMenu: '📑 Порядок меню',
    superStatusTrial: 'Пробный',
    superStatusActive: 'Активный',
    superStatusExpired: 'Истёк',
    superStatusCancelled: 'Отменён',
    superPeriodToday: 'Сегодня',
    superPeriodWeek: 'Неделя',
    superPeriodMonth: 'Месяц',
    superPeriodYear: 'Год',
    superPeriodCustom: 'Другой',
    superThCash: 'Наличные',
    superThTerminal: 'Терминал',
    superThClick: 'Click',
    superThPayme: 'Payme',
    superThRevenue: 'Итого',
    superBtnView: 'Показать',
    superTotalIncome: 'Общий доход',
    superSessionIncome: 'Доход от сессий',
    superTotalExpenses: 'Общие расходы',
    superNetProfit: 'Чистая прибыль',
    superByBranchAnalysis: 'Анализ по филиалам',
    superThBranchName: 'Название филиала',
    superThSnackIncome: 'Доход от снеков',
    superUnitPcs: 'шт',
    superTooltipDetails: 'Подробнее',
    superTotalRow: 'ИТОГО',
    superAllBranches: 'Все филиалы',
    superStatTotalOwners: 'Всего владельцев',
    superStatActiveSubscriptions: 'Активные подписки',
    superStatTrialPeriod: 'Пробный период',
    superStatTotalComputers: 'Всего компьютеров',
    superThOwner: 'Владелец',
    superThPlan: 'Тариф',
    superThStatus: 'Статус',
    superThExpires: 'Истекает',
    superThActions: 'Действия',
    superNoPlan: 'Без тарифа',
    superDayAbbr: 'д',
    superBtnAssign: 'Назначить',
    superDetailExpenses: '💸 Расходы',
    superDetailSnack: '🍕 Доход от снеков',
    superDetailSessions: '🎮 Доход от сессий',
    superBtnClose: '✕ Закрыть',
    superBtnBack: '← Назад',
    superThDate: 'Дата',
    superThDescription: 'Описание',
    superThAmount: 'Сумма',
    superThProduct: 'Продукт',
    superThQty: 'Кол-во',
    superThPackage: 'Пакет',
    superThSessions: 'Сессии',
    superThClient: 'Клиент',
    superNoExpenses: 'Нет расходов',
    superRecordsCount: 'записей',
    superTotalSnackIncome: 'Общий доход от снеков',
    superSnackProductsHeading: '🛒 Что продано',
    superNoData: 'Нет данных',
    superByBranchHeading: '📍 По филиалам',
    superOrdersCount: 'заказов',
    superSessionsCount: 'сессий',
    superTotalSessionIncome: 'Общий доход от сессий',
    superByPackageHeading: '📦 Доход по пакетам',
    superNoPackage: 'Без пакета',
    superNoSessions: 'Нет сессий',
    superRecentSessions: '🕐 Последние сессии',
    superGuestName: 'Гость',
    superStatusEnded: 'Завершён',
    superModalSubTitle: 'Назначить подписку',
    superModalSubFor: 'Подписка для {name}',
    superLabelPlan: 'ТАРИФ',
    superLabelDuration: 'СРОК',
    superLabelNote: 'ПРИМЕЧАНИЕ',
    superMonthAbbr: 'мес',
    superUnlimited: 'безлимит',
    superPlaceholderOptional: 'Необязательно...',
    superNoLabsFound: 'Филиалы не найдены.',
    superMsgActiveBranch: '📍 Активный филиал: {name}',
    superSelectLabTitle: '🎯 Активный филиал',
    superSelectLabHint: 'Нажмите на филиал — данные на всех страницах будут отфильтрованы по нему.',
    superBadgeActive: '✓ АКТИВЕН',
    superAvailableSuffix: 'свободно',
    superPerHour: 'час',
    superMsgSubSet: '✅ Подписка для {name} установлена',
    superConfirmCancel: 'Вы хотите отменить подписку для {name}?',
    superMsgSubCancelled: 'Подписка {name} отменена',
    superMsgMenuSaved: '✅ Порядок меню сохранён. Обновите страницу.',
    superMsgMenuReset: '↺ Восстановлен исходный порядок.',
    superMenuOrderTitle: '📑 Настройка порядка боковой панели',
    superMenuOrderHint: 'Перетаскивайте страницы или меняйте порядок кнопками ↑ ↓. Изменения сохраняются только в этом браузере.',
    superBtnSave: '💾 Сохранить',
    superBtnResetOrder: '↺ Исходный порядок',
    superErrorLoading: 'Ошибка загрузки',
  },
};

export const defaultLang = localStorage.getItem('lang') || 'uz';
